angular.module("estoffice.i18n", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {
  "button.choose_file": "Choose file",
  "button.close": "Close",
  "button.preview": "Preview",
  "button.publish": "Publish",
  "general.add": "Add",
  "general.button.export": "Export",
  "general.button.next": "Next",
  "general.copied": "Copied!",
  "general.copy": "copy",
  "general.current.lang": "en",
  "general.edit.title": "Edit",
  "general.filters.add": "Select...",
  "general.filters.between": "Between...",
  "general.filters.date.after": "After...",
  "general.filters.date.before": "Before...",
  "general.filters.date.before.30": "Before 30 days ago",
  "general.filters.date.before.7": "Before 7 days ago",
  "general.filters.date.month": "For month...",
  "general.filters.date.on": "On...",
  "general.filters.date.on.short": "date",
  "general.filters.date.today": "Today",
  "general.filters.date.within.30": "Within last 30 days",
  "general.filters.date.within.7": "Within last 7 days",
  "general.filters.date.yesterday": "Yesterday",
  "general.filters.exactly": "Exactly...",
  "general.filters.has.no": "No",
  "general.filters.has.yes": "Yes",
  "general.filters.hit.enter": "hit enter to apply",
  "general.filters.less": "Less than...",
  "general.filters.more": "More than...",
  "general.gallery.upload": "+ Upload",
  "general.link": "link",
  "general.modal.are.you.sure": "Are you sure?",
  "general.modal.doesnt.work.message": "If you want this feature, drop us a line at support@estoffice.com.",
  "general.modal.doesnt.work.title": "Doesn't work yet",
  "general.modal.got.it": "OK",
  "general.month.april": "April",
  "general.month.august": "August",
  "general.month.december": "December",
  "general.month.february": "February",
  "general.month.january": "January",
  "general.month.july": "July",
  "general.month.june": "June",
  "general.month.march": "March",
  "general.month.may": "May",
  "general.month.november": "November",
  "general.month.october": "October",
  "general.month.september": "September",
  "general.months": "months",
  "general.saving": "Saving...",
  "general.search.not.found": "No matches found",
  "general.search.placeholder": "Search...",
  "general.update": "Update",
  "general.working.with": "Working with",
  "lead.popup.area": "Area",
  "lead.popup.expires.days": "days",
  "lead.popup.expires.days.full": "days",
  "lead.popup.expires.leads.full": "leads",
  "lead.popup.links.room": "-room",
  "lead.popup.links.sqm": "sq.m.",
  "lead.popup.num": "Number",
  "leads.buttons.add.note": "Add note",
  "leads.buttons.bulk.edit": "Bulk edit",
  "leads.buttons.bulk.note.adding": "Bulk note adding",
  "leads.buttons.bulk.note.update": "Update",
  "leads.buttons.bulk.note.with.note": "leads with note",
  "leads.buttons.bulk.status.change": "Bulk status change",
  "leads.buttons.bulk.status.change.status.of": "Change status of",
  "leads.buttons.bulk.status.leads.to": "leads to",
  "leads.buttons.change.status": "Change status",
  "leads.buttons.sort": "Sort by",
  "leads.buttons.sort.date.updated": "Date updated",
  "leads.buttons.sort.lead.status": "Lead status",
  "leads.mobile.add.from.clipboard": "Paste phone number from clipboard",
  "leads.mobile.add.long.tap": "use long press",
  "leads.mobile.add.toast.msg": "New lead was created!",
  "leads.search.create.new": "New Lead",
  "leads.search.create.new.appeal.source": "Appeal source",
  "leads.search.create.new.disabled.tooltip": "You haven't fill all required fields",
  "leads.search.create.new.items": "Items of interest",
  "leads.search.create.new.newlead": "New Lead",
  "leads.search.create.new.projects": "Projects",
  "leads.search.create.new.save.and.add.to.clipboard": "Save and Add to Clipboard",
  "leads.search.create.new.save.lead": "Save lead",
  "leads.search.create.new.segmentation": "Segmentation",
  "leads.search.create.new.status.tooltip": "Choose lead status...",
  "leads.search.records": "leads",
  "leads.search.tab.tooltip": "Pressing tab will activate this input",
  "leads.sidebar.filter.and.work": "Filter and Work",
  "leads.sidebar.lead.action": "Lead action - 4W",
  "leads.sidebar.lead.has.email": "Has email",
  "leads.sidebar.lead.has.note": "Has lead note",
  "leads.sidebar.lead.has.phone": "Has phone",
  "leads.sidebar.lead.has.task": "Has lead task(s)",
  "leads.sidebar.lead.items.interest": "Items of interest",
  "leads.sidebar.lead.items.interest.1r": "1r",
  "leads.sidebar.lead.items.interest.2r": "2r",
  "leads.sidebar.lead.items.interest.3r": "3r",
  "leads.sidebar.lead.items.interest.ground": "ground",
  "leads.sidebar.lead.items.interest.ready": "ready",
  "leads.sidebar.lead.items.interest.studio": "studio",
  "leads.sidebar.lead.project": "Project",
  "leads.sidebar.lead.record": "Lead record",
  "leads.sidebar.lead.status": "Lead status",
  "leads.sidebar.main.what": "What",
  "leads.sidebar.main.what.reservation.options": "Reservation options",
  "leads.sidebar.main.what.reservation.options.duration": "Duration",
  "leads.sidebar.main.what.reservation.options.expiration": "Expiration",
  "leads.sidebar.main.what.reservation.options.status": "Status",
  "leads.sidebar.main.when": "When",
  "leads.sidebar.main.where": "Where",
  "leads.sidebar.main.where.floor.area": "Floor area",
  "leads.sidebar.main.where.rooms": "Rooms",
  "leads.sidebar.main.where.sections": "Sections",
  "leads.sidebar.main.where.storey": "Storey",
  "leads.sidebar.main.where.type": "Type",
  "leads.sidebar.main.where.type.group.individual": "Individual housing",
  "leads.sidebar.main.where.type.group.main": "Group housing and commerce",
  "leads.sidebar.main.where.type.group.other": "Other",
  "leads.sidebar.main.where.unique.id": "Unique ID",
  "leads.sidebar.main.who": "Who",
  "leads.sidebar.notes": "Notes",
  "leads.sidebar.notes.content": "Content",
  "leads.sidebar.notes.date": "Date added",
  "leads.sidebar.notes.has.notes": "Has notes",
  "leads.sidebar.notes.quantity": "Quantity",
  "leads.sidebar.only.leads": "Only leads",
  "leads.sidebar.only.my.leads": "Only assigned to me",
  "leads.sidebar.select.created": "Created",
  "leads.sidebar.select.note.user": "Created note",
  "leads.sidebar.select.price.1sqm": "1 sqm price",
  "leads.sidebar.select.price.total": "Total price",
  "leads.sidebar.select.reservation.status.active": "Active",
  "leads.sidebar.select.reservation.status.inactive": "Inactive",
  "leads.sidebar.select.total.area": "Total area",
  "leads.sidebar.select.updated": "Last updated",
  "leads.sidebar.select.what.booked": "Booked",
  "leads.sidebar.select.what.canceled.deal": "Canceled deal",
  "leads.sidebar.select.what.extended.reservation": "Extended reservation",
  "leads.sidebar.select.what.interested": "Interested",
  "leads.sidebar.select.what.purchased": "Purchased",
  "leads.sidebar.select.what.updated.deal": "Updated deal",
  "leads.sidebar.smart.tasks": "Smart-tasks",
  "leads.sidebar.smart.tasks.everyday": "every day",
  "leads.sidebar.smart.tasks.once": "every Wednesday",
  "leads.sidebar.smart.tasks.twice": "every Tuesday and Friday",
  "leads.sidebar.unit.status": "Unit status",
  "leads.sidebar.user.created": "User that created",
  "leads.sidebar.user.updated": "User that updated",
  "leads.table.created.at": "Date created",
  "leads.table.created.by": "Created by",
  "leads.table.ibp": "Interested / booked / purchased",
  "leads.table.last.action": "Last action",
  "leads.table.updated.by": "Updated by",
  "navi.all_sold": "All sold",
  "navi.area": "Total area",
  "navi.button": "navi",
  "navi.in_stock": "In stock",
  "navi.incoming": "In stock soon",
  "navi.modal.back": "Back",
  "navi.modal.title": "Interactive navigation",
  "navi.not_in_stock": "Not in stock",
  "navi.num.of.storeys": "# of storeys",
  "navi.price.from": "Price from",
  "navi.price.per.m": "/m",
  "navi.publish.error": "Error publishing navi",
  "navi.publish.preview": "Preview",
  "navi.publish.success": "Interactive navigation was successfully published",
  "navi.return.to.navi": "Back to the master plan",
  "navi.scroll.horizontally": "scroll horizontally",
  "navi.section.class": "Class",
  "navi.sold.out": "Sold out",
  "objects.navi.panel.group.see_also": "See also",
  "objects.navi.panel.group.selected": "Selected",
  "projects.area.fill": "Set",
  "projects.area.kitchen": "Kitchen",
  "projects.area.living": "Living",
  "projects.area.plot.size": "Plot size",
  "projects.area.set.commercial": "Set total area of commercial units",
  "projects.area.set.plot": "Set size of land plots",
  "projects.area.set.text": "Total area is a required information. Living and kitchen areas are optional.",
  "projects.area.set.title": "Set total, living and kitchen area",
  "projects.area.show.all": "Show all three",
  "projects.area.total": "Total",
  "projects.basic.basement": "Basement floor",
  "projects.basic.bind_to_single_floor": "Bind to a single floor",
  "projects.basic.commercial": "Commercial units",
  "projects.basic.completed": "Completed",
  "projects.basic.completion.date": "Completion date",
  "projects.basic.completion.date.unset": "not set",
  "projects.basic.construction": "Construction",
  "projects.basic.construction.stage": "Construction stage",
  "projects.basic.create": "Create units",
  "projects.basic.create.check": "Check twice! You can't change base later.",
  "projects.basic.create.cta": "Create units",
  "projects.basic.floor_override": "Floor number",
  "projects.basic.grid.edit": "Edit grid",
  "projects.basic.grid.params": "Grid parameters",
  "projects.basic.mark": "Mark",
  "projects.basic.merge": "Merge / Undo",
  "projects.basic.nounit": "No unit",
  "projects.basic.parking": "Underground parking",
  "projects.basic.per.storey": "Units per storey",
  "projects.basic.split": "Split / Undo",
  "projects.basic.stage.completion": "Stage and Completion date",
  "projects.basic.storeys": "Storeys",
  "projects.basic.units.horizontally": "Units horizontally",
  "projects.basic.units.vertically": "Units vertically",
  "projects.features.custom.fields": "Custom Fields",
  "projects.features.custom.fields.no": "You haven't added a single custom field. Go to Customizations to add one.",
  "projects.features.features": "Features",
  "projects.features.helptext.1part": "To apply custom field to all units press",
  "projects.features.helptext.2part": "would apply feature or custom-data to the first, second and Nth column respectively.",
  "projects.images.all.units": "all units",
  "projects.images.floor.plans": "Floor plans",
  "projects.images.floor.plans.units": "Floor plans of units",
  "projects.images.linked.to": "Linked to",
  "projects.images.linked.to.units": "units",
  "projects.images.master.plans": "Master plans",
  "projects.images.visual.units": "Visualizations of units",
  "projects.numbering.button.autoset": "Auto set",
  "projects.numbering.button.startover": "Start over",
  "projects.numbering.id": "In-tower id",
  "projects.numbering.id.block.block": "Block",
  "projects.numbering.id.block.corresponds": "corresponds to Block B1, unit #12",
  "projects.numbering.id.block.example": "Example: B1-12",
  "projects.numbering.id.block.first": "Define the format of in-block id",
  "projects.numbering.id.block.first.text": "Add separators and custom text if you need. Then click \"Auto set\". Made an error? Just hit \"Start over\".",
  "projects.numbering.id.block.second": "Edit unit # in each cell",
  "projects.numbering.id.block.second.text": "Second input field is editable. Make sure each unit has a unique number.",
  "projects.numbering.id.floor": "Floor",
  "projects.numbering.id.tower.corresponds": "corresponds to Tower B1, floor #2, unit #3",
  "projects.numbering.id.tower.example": "Example: B1-02-3",
  "projects.numbering.id.tower.first": "Set apartment number",
  "projects.numbering.id.tower.first.text": "Use input fields under columns. Later your input would be used to generate in-tower id.",
  "projects.numbering.id.tower.second": "Define the format of in-tower id",
  "projects.numbering.id.tower.second.text": "Edit generated numbers if you need. Second input field is editable.",
  "projects.numbering.id.tower.tower": "Tower",
  "projects.numbering.id.unit": "Unit",
  "projects.numbering.number.first": "First unit #",
  "projects.numbering.number.last": "Last unit #",
  "projects.numbering.number.split": "Number just the first of the splitted units",
  "projects.numbering.pass": "Pass-through",
  "projects.numbering.skip.commercial": "Skip commercial units",
  "projects.numbering.title": "Numbering",
  "projects.page.add.new.building": "Add a multistorey building",
  "projects.page.add.new.project": "+ Add New Project",
  "projects.page.add.new.project.popup.title": "New Project",
  "projects.page.add.new.villas": "Add parking / storage / private housing",
  "projects.page.edit.prices": "Edit prices",
  "projects.page.edit.units": "Edit units",
  "projects.page.no.projects": "No projects yet",
  "projects.page.popup.add.block": "Add a block",
  "projects.page.popup.add.section": "Add a section",
  "projects.page.popup.blocks": "Blocks",
  "projects.page.popup.completion": "Completion",
  "projects.page.popup.edit.title": "Edit",
  "projects.page.popup.sections": "Sections",
  "projects.page.popup.start.of.sales": "Start of sales",
  "projects.page.popup.status": "Status",
  "projects.page.popup.successfully.created": "Successfully created!",
  "projects.page.popups.add.block": "Add",
  "projects.page.popups.add.building": "Add building",
  "projects.page.popups.add.section": "Add",
  "projects.page.popups.block.index": "Index",
  "projects.page.popups.block.index.placeholder": "Number, letter, etc...",
  "projects.page.popups.building.name": "Building name",
  "projects.page.popups.building.name.placeholder": "House #1, Crystal Tower...",
  "projects.page.popups.contact.page": "Contact page link",
  "projects.page.popups.description.page": "Link to description",
  "projects.page.popups.if.diff": "if different from project...",
  "projects.page.popups.project.city": "City",
  "projects.page.popups.project.city.placeholder": "Tokio...",
  "projects.page.popups.project.country": "Country",
  "projects.page.popups.project.create": "Create project",
  "projects.page.popups.project.location": "Location",
  "projects.page.popups.project.location.placeholder": "Street...",
  "projects.page.popups.project.name": "Project name",
  "projects.page.popups.project.name.placeholder": "Crystal City...",
  "projects.page.popups.section.index": "Index",
  "projects.page.popups.villas.blocks": "Blocks",
  "projects.page.popups.villas.create.holder": "Create holder",
  "projects.page.popups.villas.holder.name": "Villas holder name",
  "projects.page.popups.villas.holder.name.placeholder": "Villas and townhouses...",
  "projects.page.sheets.step1.create.btn": "Create table",
  "projects.page.sheets.step1.create.text": "Or create table-template for a new date.",
  "projects.page.sheets.step1.drafts": "Drafts",
  "projects.page.sheets.step1.hint": "Please specify a target start date for prices you want to add. This will allow us to create all the right columns.",
  "projects.page.sheets.step1.li1": "change prices of all or some of the units",
  "projects.page.sheets.step1.li2": "increase/decrease price by a percentage or amount",
  "projects.page.sheets.step1.li3": "round the calculated price",
  "projects.page.sheets.step1.subtitle": "Using this table you will be capable to:",
  "projects.page.sheets.step1.title": "Step 1. Create table-template",
  "projects.page.sheets.step1.unitsData.li1": "set the areas (total, living, kitchen)",
  "projects.page.sheets.step1.unitsData.li2": "set the number of rooms",
  "projects.page.sheets.step1.unitsData.li3": "set numbering",
  "projects.page.sheets.step1.unitsData.li4": "change unit type",
  "projects.page.sheets.step1.unitsData.li5": "set the type of layout",
  "projects.page.sheets.step1.unitsData.li6": "set government id",
  "projects.page.sheets.step2.cancel.btn": "Cancel and delete table",
  "projects.page.sheets.step2.cancel.btn.toast": "Table-draft was deleted!",
  "projects.page.sheets.step2.import.btn": "Import table to EstOffice",
  "projects.page.sheets.step2.import.btn.toast": "Successfully imported!",
  "projects.page.sheets.step2.import.error": "Error during import. Please correct mistakes in your spreadsheet and try importing again.",
  "projects.page.sheets.step2.title": "Step 2. Editing the table",
  "projects.page.sheets.step2.when.finished": "When finished with editing – import your table.",
  "projects.page.sheets.step2.you.can.edit": "You may edit values in the columns marked with active orange color.",
  "projects.page.units.noprice": "Unit(s) without price:",
  "projects.price.prices": "Prices",
  "projects.price.unique.1part": "If each unit has a separate price – use another method. Open this",
  "projects.price.unique.2part": "Paste prices of units on the first floor into the first column. The formula will create a string of prices, separated by spaces. Now paste it into the first unit of the first floor. Repeat for each floor of the tower.",
  "projects.price.unique.link": "Google Spreadsheet",
  "projects.progress.area": "Area",
  "projects.progress.basic": "Basic",
  "projects.progress.features": "Features",
  "projects.progress.images": "Images",
  "projects.progress.num": "Numbering",
  "projects.progress.price": "Price",
  "projects.progress.published": "Published",
  "projects.progress.review": "Review",
  "projects.progress.rooms": "Rooms",
  "projects.review.public.view.tip": "Manage access to sections using «Public view & navigation» on screen",
  "projects.review.public.view.tip.projects": "Projects",
  "projects.review.publishing.status": "Publishing status",
  "projects.review.publishing.status.draft": "Draft",
  "projects.review.publishing.status.published": "Published",
  "projects.review.publishing.status.unknown": "Unknown",
  "projects.review.quick.status": "Quick Status Change",
  "projects.review.quick.status.booked": "Booked",
  "projects.review.quick.status.free": "Free, in stock",
  "projects.review.quick.status.notinstock": "Not in stock",
  "projects.review.quick.status.sold": "Sold",
  "projects.review.save": "Save",
  "projects.review.save.modal.draft.content": "Sales reps won't see this section.",
  "projects.review.save.modal.draft.title": "Saved as Draft",
  "projects.review.save.modal.published.content": "Section has Production status. Sales reps will be able to book and sell.",
  "projects.review.save.modal.published.title": "Published",
  "projects.review.text": "Review all the information. Go back to any stage if you need to change anything.",
  "projects.review.title": "Review and Publish",
  "projects.rooms.commercial": "Commercial",
  "projects.rooms.set.text": "Enter 1, 2, 3, etc. for each unit. To set a common value, use input fields above each column.",
  "projects.rooms.set.title": "Set numbers of living rooms",
  "projects.rooms.statistics": "Statistics",
  "projects.rooms.total": "Total",
  "projects.set.all.unit.type": "Set type of all units",
  "projects.unit.type.apt": "Apt.",
  "projects.unit.type.commercial": "Comm.",
  "projects.unit.type.plot": "Plot",
  "projects.unit.type.villa": "Villa",
  "reports.page.byprojects.all.time": "All time",
  "reports.page.byprojects.annual": "Annual report",
  "reports.page.byprojects.deals.full": "by 100% payment",
  "reports.page.byprojects.deals.value.total": "Income",
  "reports.page.byprojects.deals.value.total.mln": "income, mln",
  "reports.page.byprojects.monthly": "Monthly report",
  "reports.page.byprojects.nodata": "No data",
  "reports.page.byprojects.weekly": "Weekly report",
  "reports.page.dashboard.active.leads": "leads with target action",
  "reports.page.dashboard.created": "created new",
  "reports.page.dashboard.data.updated": "Data updated:",
  "reports.page.dashboard.day": "Day",
  "reports.page.dashboard.deals": "deals",
  "reports.page.dashboard.deals.value": "deals value",
  "reports.page.dashboard.interacted": "interacted",
  "reports.page.dashboard.interests": "interests",
  "reports.page.dashboard.last": "Last",
  "reports.page.dashboard.month": "Month",
  "reports.page.dashboard.new.leads": "new leads",
  "reports.page.dashboard.percentage.tooltip": "comparing to a previous period",
  "reports.page.dashboard.q1": "Who is the leader in lead nurturing?",
  "reports.page.dashboard.q1.tip": "Sum of daily counts per employee. Bigger number indicates that an employee contacted more leads during last 30/90 days. Following interaction types are included: notes, tasks, calls, custom fields updates.",
  "reports.page.dashboard.q2": "What are the most active days for lead nurturing?",
  "reports.page.dashboard.q2.tip": "Shows the number of created and updated leads per day. If values of updated and created are equal, only new leads were touched on that day.",
  "reports.page.dashboard.reservations": "reservations",
  "reports.page.dashboard.updated.leads": "leads with interaction",
  "reports.page.dashboard.week": "Week",
  "reports.page.dashboard.year": "Year",
  "reports.page.filter.all.projects": "All projects",
  "reports.page.lead.working.q1": "Avg amount of days in the current status",
  "reports.page.lead.working.q1.tip": "The statuses in the chart belong to the sales funnel. So the leads are supposed to be moving along the sales funnel, not be stuck for many days.",
  "reports.page.menu.employee.all": "All employees",
  "reports.page.menu.employee.sales": "Sales by employee",
  "reports.page.menu.stock.analysis": "Stock",
  "reports.page.sales.by.time.count": "count",
  "reports.page.sales.by.time.income": "income",
  "reports.page.sales.by.time.months": "by months",
  "reports.page.sales.by.time.sqm": "in sqm",
  "reports.page.sales.by.time.value": "value",
  "reports.page.sales.by.time.weeks": "by weeks",
  "reports.page.sidebar.byprojects": "Projects overview",
  "reports.page.sidebar.dashboard": "Dashboard",
  "reports.page.sidebar.export.data": "Export data",
  "reports.page.sidebar.intervals": "Day, month, year",
  "reports.page.sidebar.lead.working": "Lead nurturing",
  "reports.page.sidebar.leads.by.status": "Employee leads by status",
  "reports.page.sidebar.projects.alltime": "Sales over time",
  "reports.page.stock.analysis.q1": "Do we have enough stock to sell?",
  "reports.page.stock.analysis.q1.tip": "report includes units that have defined total area",
  "reports.page.stock.analysis.q2": "Is what we have in stock in demand? Maybe we have some stale goods?",
  "reports.page.stock.analysis.q2.tip": "only free and booked units are taken into account",
  "reports.page.stock.analysis.q3": "Apartments of which type a present in the stock?",
  "settings.document.templates.title": "Document templates",
  "settings.opportunity.labels.title": "Stages and Statuses",
  "settings.page.customizations.custom.table.name": "Name",
  "settings.page.customizations.custom.type.choice": "Choice",
  "settings.page.customizations.custom.type.date": "Date",
  "settings.page.customizations.custom.type.number": "Number",
  "settings.page.customizations.custom.type.text": "Text",
  "settings.page.customizations.customizations": "Customizations",
  "settings.page.customizations.default.currency": "Default currency",
  "settings.page.customizations.land.measure": "Land plot unit measure",
  "settings.page.customizations.lead.statuses": "Lead statuses",
  "settings.page.customizations.lead.statuses.placeholder": "Status name...",
  "settings.page.customizations.lead.statuses.separator": "+ Add a group",
  "settings.page.customizations.menu.appeal.sources": "Appeal sources",
  "settings.page.customizations.menu.custom.fields": "Custom fields",
  "settings.page.customizations.menu.customizations": "Customizations",
  "settings.page.customizations.menu.embed": "Embed on a website",
  "settings.page.customizations.menu.integrations": "Integrations",
  "settings.page.customizations.menu.loans": "Loans",
  "settings.page.customizations.menu.requests": "Appeals",
  "settings.page.customizations.menu.stacking.plan": "Stacking plan",
  "settings.page.customizations.menu.users": "Users",
  "settings.page.customizations.price.lists": "Price lists",
  "settings.page.customizations.price.lists.begin": "Begin",
  "settings.page.customizations.price.lists.end": "End",
  "settings.page.customizations.price.lists.name": "Name",
  "settings.page.customizations.price.lists.parent": "Parent",
  "settings.page.customizations.time.zone": "Time zone",
  "settings.page.customizations.unit.features": "Unit features",
  "settings.page.customizations.unit.features.abbr.placeholder": "Abbreviation...",
  "settings.page.customizations.unit.features.name.placeholder": "Feature name...",
  "settings.page.customizations.unit.features.table.abbr": "Abbr.",
  "settings.page.customizations.unit.features.table.name": "Name",
  "settings.page.customizations.unit.status.cant.delete_1": "Total units with this status:",
  "settings.page.customizations.unit.status.cant.delete_2": "Set a new status to replaced removed one.",
  "settings.page.customizations.unit.status.confirm.delete": "Please confirm status removal",
  "settings.page.customizations.unit.statuses": "Unit statuses",
  "settings.page.customizations.unit.statuses.placeholder": "Status name...",
  "settings.page.customizations.unit.statuses.remove": "Unit status removal",
  "settings.page.customizations.unit.statuses.type.booked": "Booked",
  "settings.page.customizations.unit.statuses.type.free": "Free, in stock",
  "settings.page.customizations.unit.statuses.type.notinstock": "Not in stock",
  "settings.page.customizations.unit.statuses.type.sold": "Sold",
  "settings.page.users.deactivated.at": "Deactivated at",
  "settings.page.users.modal.name": "Full name",
  "settings.page.users.modal.name.caution": "Please, don't use dots, write full name.",
  "settings.page.users.modal.name.placeholder": "John Doe",
  "settings.page.users.modal.note": "Note",
  "settings.page.users.modal.password": "Password",
  "settings.page.users.modal.role": "Role",
  "settings.page.users.modal.title.newuser": "New user",
  "settings.page.users.modal.title.update": "Update user",
  "settings.page.users.title.active": "Active",
  "settings.page.users.title.deactivated": "Deactivated",
  "svg.upload.draft_plan_image_hint": "Upload an image that shows the section boundaries and their names. Create all sections in EstOffice.",
  "svg.upload.draft_plan_image_label": "Navigation markup example",
  "svg.upload.format.error": "You have uploaded improperly formatted svg file. Please contact technical support to get additional help.",
  "svg.upload.house.public.view.and.plan": "Public view & navigation",
  "svg.upload.navi_link_label": "Interactive navigation link:",
  "svg.upload.preview_image_label": "Final image",
  "svg.upload.published_navi": "Published navigation",
  "svg.upload.section_published_flag": "published",
  "svg.upload.sections.status.tip": "If nothing is selected, all published sections will appear in public view.",
  "svg.upload.sections.status.title": "Public status of sections",
  "svg.upload.source_image_hint": "High resolution, horizontal orientation, each section should be clearly visible on the image.",
  "svg.upload.source_image_label": "Source image",
  "svg.upload.success": "SVG-file was successfully uploaded",
  "svg.upload.svg_file_label": "Prepared markup SVG-file",
  "svg.upload.title": "Public view",
  "toast.lead.was.added": "Lead was added!",
  "unit.info.room": "room",
  "unit.popup.add": "+ Add",
  "unit.popup.add.url": "+ Add phone, email or URL",
  "unit.popup.apartment": "apartment",
  "unit.popup.attic": "attic",
  "unit.popup.cancel": "Cancel",
  "unit.popup.change.params.edit.area": "Edit total area",
  "unit.popup.change.params.edit.auto.exchange.rate": "Auto exchange rate",
  "unit.popup.change.params.edit.cost": "Total cost",
  "unit.popup.change.params.edit.exchange.rate": "Exchange rate",
  "unit.popup.change.params.edit.for.1usd": "for 1 USD",
  "unit.popup.change.params.edit.per.sqm": "Price of sqm",
  "unit.popup.change.params.edit.price": "Edit price",
  "unit.popup.change.params.edit.price.per.meter": "set price per sqm",
  "unit.popup.change.params.edit.price.per.unit": "set unit total cost",
  "unit.popup.change.params.title": "Change area and price",
  "unit.popup.comment": "Comment",
  "unit.popup.comment.placeholder": "Memo about lead",
  "unit.popup.commercial.unit": "commercial unit",
  "unit.popup.contact": "Contact",
  "unit.popup.cottage": "cottage",
  "unit.popup.custom.fields": "Custom Fields",
  "unit.popup.duplex": "duplex",
  "unit.popup.email": "Email",
  "unit.popup.hotel.type": "hotel type",
  "unit.popup.land.plot": "land plot",
  "unit.popup.meter": "m",
  "unit.popup.name": "Name",
  "unit.popup.name.placeholder": "Name Lastname",
  "unit.popup.noname": "No name",
  "unit.popup.none": "None",
  "unit.popup.note.long": "Note",
  "unit.popup.parking.lot": "parking lot",
  "unit.popup.pavement.parking": "pavement parking",
  "unit.popup.payment.type.deposit": "Deposit",
  "unit.popup.payment.type.fine": "Fine",
  "unit.popup.payment.type.first": "First payment",
  "unit.popup.payment.type.other": "Other",
  "unit.popup.payment.type.periodical": "Periodical payment",
  "unit.popup.payment.type.refund": "Refund",
  "unit.popup.phone": "Phone",
  "unit.popup.save": "Save",
  "unit.popup.store.room": "store room",
  "unit.popup.townhouse": "townhouse",
  "unit.popup.unitdeallead.integration.contact": "contact",
  "unit.popup.unitdeallead.integration.deal": "deal",
  "unit.popup.unitdeallead.integration.units": "units",
  "unit.popup.unitdeallead.payment.select.no": "No",
  "unit.popup.unitdeallead.payment.select.one": "Once a month",
  "unit.popup.unitdeallead.payment.select.three": "Quarterly",
  "unit.popup.unitdeallead.payment.select.two": "Once every two months",
  "unit.popup.unitdeallead.payment.select.yes": "Yes",
  "unit.popup.url": "phone, email or URL",
  "unit.popup.villa": "villa",
  "unit.popup.work_with_lead.in_proposal": "Proposed",
  "unit.search.found.total.in.project": "Found <b>{{ total }}</b> apartments in <b>{{ name }}</b>",
  "unit.search.open.filters": "Open filters",
  "unit.search.show.other.project.results": "Look in other projects ({{ total }})",
  "unit.search.show.results": "Show results",
  "units.page.add.lead.mobile": "Add Lead from Mobile",
  "units.page.filters": "Filters",
  "units.page.filters.show": "show filters",
  "units.page.noresults.neighbours.close": "close match",
  "units.page.noresults.neighbours.exact": "exact match",
  "units.page.noresults.reset": "Reset filter",
  "units.page.nounits": "No units yet",
  "units.page.parking": "Parking",
  "units.page.print.booked.reserved": "booked, reserved",
  "units.page.print.stacking.plan.by": "Stacking plan by EstOffice dated",
  "units.page.results.in.section": "Found in section",
  "units.page.search.panel.close.settings": "Back to filters",
  "units.page.search.panel.display": "Display",
  "units.page.search.panel.display.house": "by buildings/phases",
  "units.page.search.panel.display.section": "by sections",
  "units.page.search.panel.from": "from",
  "units.page.search.panel.price": "Total price",
  "units.page.search.panel.price1sqm": "1sqm price",
  "units.page.search.panel.prices": "Prices",
  "units.page.search.panel.reset": "Reset",
  "units.page.search.panel.rooms": "Rooms",
  "units.page.search.panel.status": "Status",
  "units.page.search.panel.to": "to",
  "units.page.search.panel.view": "View",
  "units.page.search.panel.view.fullsize": "fullsize view",
  "units.page.search.panel.view.hide.sold": "hide sold",
  "units.page.search.panel.view.minimize": "compact view",
  "units.page.search.panel.view.show.sold": "show sold",
  "units.page.search.panel.view.standard": "standard view",
  "units.page.section": "Section",
  "units.page.sidebar.all.photos": "all photos",
  "units.page.sidebar.object": "Building in selected project",
  "units.page.sidebar.open": "open",
  "units.page.sidebar.project": "Project",
  "units.page.sidebar.public.link": "Public link",
  "units.page.sidebar.quarter": "Q",
  "units.page.sidebar.sections": "Sections / blocks / groups",
  "units.page.storey": "storey",
  "working.with.filters.modal.title": "Save filters",
  "working.with.filters.save.error": "Failed to save filters",
  "working.with.filters.saved": "Filters saved",
  "working.with.link.copied": "Link copied",
  "working.with.link.copy.error": "Failed to copy link"
});

$translateProvider.translations("ru", {
  "button.choose_file": "Выберите файл",
  "button.close": "Закрыть",
  "button.preview": "Предпросмотр",
  "button.publish": "Опубликовать",
  "general.add": "Добавить",
  "general.button.export": "Экспорт",
  "general.button.next": "Далее",
  "general.copied": "Скопировано!",
  "general.copy": "скопировать",
  "general.current.lang": "ru",
  "general.edit.title": "Редактирование",
  "general.filters.add": "Выберите...",
  "general.filters.between": "Диапазон...",
  "general.filters.date.after": "После...",
  "general.filters.date.before": "До...",
  "general.filters.date.before.30": "Больше месяца назад",
  "general.filters.date.before.7": "Больше недели назад",
  "general.filters.date.month": "За месяц...",
  "general.filters.date.on": "Точная дата...",
  "general.filters.date.on.short": "дата",
  "general.filters.date.today": "Сегодня",
  "general.filters.date.within.30": "За последние 30 дней",
  "general.filters.date.within.7": "За последние 7 дней",
  "general.filters.date.yesterday": "Вчера",
  "general.filters.exactly": "Равняется...",
  "general.filters.has.no": "Нет",
  "general.filters.has.yes": "Есть",
  "general.filters.hit.enter": "нажмите enter, чтобы применить",
  "general.filters.less": "Меньше...",
  "general.filters.more": "Больше...",
  "general.gallery.upload": "+ Загрузить",
  "general.link": "ссылка",
  "general.modal.are.you.sure": "Вы уверены?",
  "general.modal.doesnt.work.message": "Если Вы хотите эту функциональность, напишите нам на support@estoffice.com.",
  "general.modal.doesnt.work.title": "Пока что не работает",
  "general.modal.got.it": "OK",
  "general.month.april": "Апрель",
  "general.month.august": "Август",
  "general.month.december": "Декабрь",
  "general.month.february": "Февраль",
  "general.month.january": "Январь",
  "general.month.july": "Июль",
  "general.month.june": "Июнь",
  "general.month.march": "Март",
  "general.month.may": "Май",
  "general.month.november": "Ноябрь",
  "general.month.october": "Октябрь",
  "general.month.september": "Сентябрь",
  "general.months": "мес.",
  "general.saving": "Сохраняем...",
  "general.search.not.found": "Совпадений не найдено",
  "general.search.placeholder": "Поиск...",
  "general.update": "Применить",
  "general.working.with": "В работе",
  "lead.popup.area": "Площадь",
  "lead.popup.expires.days": "д.",
  "lead.popup.expires.days.full": "дней",
  "lead.popup.expires.leads.full": "лидов",
  "lead.popup.links.room": "-комн.",
  "lead.popup.links.sqm": "кв.м.",
  "lead.popup.num": "Номер",
  "leads.buttons.add.note": "Добавить заметку",
  "leads.buttons.bulk.edit": "Групп. действие",
  "leads.buttons.bulk.note.adding": "Групповая заметка",
  "leads.buttons.bulk.note.update": "Добавить к",
  "leads.buttons.bulk.note.with.note": "лидам заметку",
  "leads.buttons.bulk.status.change": "Групп. изменение статуса",
  "leads.buttons.bulk.status.change.status.of": "Изменить статус",
  "leads.buttons.bulk.status.leads.to": "лидов на",
  "leads.buttons.change.status": "Изменить статус",
  "leads.buttons.sort": "Сортировка",
  "leads.buttons.sort.date.updated": "Дата обновления",
  "leads.buttons.sort.lead.status": "Статус лида",
  "leads.mobile.add.from.clipboard": "Вставьте телефон из буфера обмена",
  "leads.mobile.add.long.tap": "длинное прикосновение",
  "leads.mobile.add.toast.msg": "Новый лид был создан!",
  "leads.search.create.new": "Новый лид",
  "leads.search.create.new.appeal.source": "Источник обращения",
  "leads.search.create.new.disabled.tooltip": "Обязательные поля не заполнены",
  "leads.search.create.new.items": "Суть запроса",
  "leads.search.create.new.newlead": "Новый лид",
  "leads.search.create.new.projects": "Проекты",
  "leads.search.create.new.save.and.add.to.clipboard": "Сохранить и подобрать квартиры",
  "leads.search.create.new.save.lead": "Сохранить лида",
  "leads.search.create.new.segmentation": "Сегментация",
  "leads.search.create.new.status.tooltip": "Выберите статус лида...",
  "leads.search.records": "лиды",
  "leads.search.tab.tooltip": "Нажатие tab активирует данное поле",
  "leads.sidebar.filter.and.work": "Фильтрация",
  "leads.sidebar.lead.action": "Действия лидов",
  "leads.sidebar.lead.has.email": "Наличие email",
  "leads.sidebar.lead.has.note": "Наличие заметки о лиде",
  "leads.sidebar.lead.has.phone": "Наличие телефона",
  "leads.sidebar.lead.has.task": "Наличие задач у лида",
  "leads.sidebar.lead.items.interest": "Суть запроса",
  "leads.sidebar.lead.items.interest.1r": "1к",
  "leads.sidebar.lead.items.interest.2r": "2к",
  "leads.sidebar.lead.items.interest.3r": "3к",
  "leads.sidebar.lead.items.interest.ground": "цоколь",
  "leads.sidebar.lead.items.interest.ready": "сдан",
  "leads.sidebar.lead.items.interest.studio": "студия",
  "leads.sidebar.lead.project": "Проект",
  "leads.sidebar.lead.record": "Информация о лидах",
  "leads.sidebar.lead.status": "Статус",
  "leads.sidebar.main.what": "Действие",
  "leads.sidebar.main.what.reservation.options": "Детали о брони",
  "leads.sidebar.main.what.reservation.options.duration": "Длительность",
  "leads.sidebar.main.what.reservation.options.expiration": "Дата снятия",
  "leads.sidebar.main.what.reservation.options.status": "Статус",
  "leads.sidebar.main.when": "Дата",
  "leads.sidebar.main.where": "Действие относится к...",
  "leads.sidebar.main.where.floor.area": "Площадь",
  "leads.sidebar.main.where.rooms": "Количество комнат",
  "leads.sidebar.main.where.sections": "Секции",
  "leads.sidebar.main.where.storey": "Этаж",
  "leads.sidebar.main.where.type": "Тип юнита",
  "leads.sidebar.main.where.type.group.individual": "Индивидуальная застройка",
  "leads.sidebar.main.where.type.group.main": "Жилье и коммерция",
  "leads.sidebar.main.where.type.group.other": "Прочее",
  "leads.sidebar.main.where.unique.id": "Уникальный ID юнита",
  "leads.sidebar.main.who": "Сотрудник, который внес",
  "leads.sidebar.notes": "Заметки к лидам",
  "leads.sidebar.notes.content": "Текст заметки",
  "leads.sidebar.notes.date": "Дата заметки",
  "leads.sidebar.notes.has.notes": "Наличие заметок",
  "leads.sidebar.notes.quantity": "Количество",
  "leads.sidebar.only.leads": "Только лиды",
  "leads.sidebar.only.my.leads": "Только мои",
  "leads.sidebar.select.created": "Дата создания",
  "leads.sidebar.select.note.user": "Сотрудник, добавивший заметку",
  "leads.sidebar.select.price.1sqm": "Цена кв.м.",
  "leads.sidebar.select.price.total": "Стоимость юнита",
  "leads.sidebar.select.reservation.status.active": "Активная",
  "leads.sidebar.select.reservation.status.inactive": "Уже снята",
  "leads.sidebar.select.total.area": "Общая площадь",
  "leads.sidebar.select.updated": "Дата обновления",
  "leads.sidebar.select.what.booked": "Забронировал",
  "leads.sidebar.select.what.canceled.deal": "Отменил сделку",
  "leads.sidebar.select.what.extended.reservation": "Продлил бронь",
  "leads.sidebar.select.what.interested": "Интересовался",
  "leads.sidebar.select.what.purchased": "Купил",
  "leads.sidebar.select.what.updated.deal": "Изменил сделку",
  "leads.sidebar.smart.tasks": "Smart-задачи",
  "leads.sidebar.smart.tasks.everyday": "каждый день",
  "leads.sidebar.smart.tasks.once": "каждую среду",
  "leads.sidebar.smart.tasks.twice": "во вторник и пятницу",
  "leads.sidebar.unit.status": "Статус юнита",
  "leads.sidebar.user.created": "Сотрудник, который создал",
  "leads.sidebar.user.updated": "Сотрудник, который обновил",
  "leads.table.created.at": "Дата создания",
  "leads.table.created.by": "Кто создал",
  "leads.table.ibp": "Запрос / Интерес / Бронь / Купил",
  "leads.table.last.action": "Посл. действие",
  "leads.table.updated.by": "Кто обновил",
  "navi.all_sold": "Все продано",
  "navi.area": "Площадь",
  "navi.button": "план",
  "navi.in_stock": "В продаже",
  "navi.incoming": "Скоро в продаже",
  "navi.modal.back": "Назад",
  "navi.modal.title": "Интерактивный план",
  "navi.not_in_stock": "Не в продаже",
  "navi.num.of.storeys": "Этажность",
  "navi.price.from": "Цена от",
  "navi.price.per.m": "м",
  "navi.publish.error": "Ошибка публикации навигации",
  "navi.publish.preview": "Предпросмотр",
  "navi.publish.success": "Интерактивная навигация была опубликована",
  "navi.return.to.navi": "Назад к генплану",
  "navi.scroll.horizontally": "скрольте горизонтально",
  "navi.section.class": "Класс",
  "navi.sold.out": "Все квартиры проданы",
  "objects.navi.panel.group.see_also": "Смотрите также",
  "objects.navi.panel.group.selected": "Выбранные",
  "projects.area.fill": "Задать",
  "projects.area.kitchen": "Кухня",
  "projects.area.living": "Жилая",
  "projects.area.plot.size": "Задать",
  "projects.area.set.commercial": "Площадь коммерческих помещений",
  "projects.area.set.plot": "Площадь земельных участков",
  "projects.area.set.text": "Общая площадь нужна для вычисления стоимости юнитов. Площадь кухни и жилая площадь – не обязательны для заполнения.",
  "projects.area.set.title": "Задайте площади помещений",
  "projects.area.show.all": "Показать все три",
  "projects.area.total": "Общая",
  "projects.basic.basement": "Нулевой этаж",
  "projects.basic.bind_to_single_floor": "Привязать к одному этажу",
  "projects.basic.commercial": "Коммерческие площади",
  "projects.basic.completed": "Сдан в эксплуатацию",
  "projects.basic.completion.date": "Дата сдачи",
  "projects.basic.completion.date.unset": "в проекте",
  "projects.basic.construction": "Строится",
  "projects.basic.construction.stage": "Стадия готовности",
  "projects.basic.create": "Создать юниты",
  "projects.basic.create.check": "Перепроверьте! В дальнейшем Вы не сможете изменить эти настройки.",
  "projects.basic.create.cta": "Создайте юниты",
  "projects.basic.floor_override": "Номер этажа",
  "projects.basic.grid.edit": "Редактирование сетки",
  "projects.basic.grid.params": "Параметры сетки",
  "projects.basic.mark": "Отметить",
  "projects.basic.merge": "Объединить / Отменить",
  "projects.basic.nounit": "Нет юнита",
  "projects.basic.parking": "Подземный паркинг",
  "projects.basic.per.storey": "Юнитов на этаже",
  "projects.basic.split": "Разделить / Отменить",
  "projects.basic.stage.completion": "Стадия и дата сдачи",
  "projects.basic.storeys": "Этажей",
  "projects.basic.units.horizontally": "По горизонтали",
  "projects.basic.units.vertically": "По вертикали",
  "projects.features.custom.fields": "Дополнительные поля",
  "projects.features.custom.fields.no": "У Вас нет ни одного дополнительного поля. Чтобы добавить, перейдите в Настройки.",
  "projects.features.features": "Отличительные особенности",
  "projects.features.helptext.1part": "Чтобы применить дополнительное значение ко всем юнитам нажмите",
  "projects.features.helptext.2part": "применят дополнительное значение или особенность к первому, второму и N-ному столбцу соответственно.",
  "projects.images.all.units": "относится ко всем",
  "projects.images.floor.plans": "Планы этажей",
  "projects.images.floor.plans.units": "Планировки юнитов",
  "projects.images.linked.to": "Относ. к",
  "projects.images.linked.to.units": "юнитам",
  "projects.images.master.plans": "Генпланы",
  "projects.images.visual.units": "Визуализации юнитов",
  "projects.numbering.button.autoset": "Нумеровать",
  "projects.numbering.button.startover": "Заново",
  "projects.numbering.id": "По id",
  "projects.numbering.id.block.block": "Блок",
  "projects.numbering.id.block.corresponds": "соответствует блоку B1, юниту #12",
  "projects.numbering.id.block.example": "Пример: B1-12",
  "projects.numbering.id.block.first": "Задайте формат id",
  "projects.numbering.id.block.first.text": "Добавляйте разделители и свой текст, если нужно. Затем нажмите \"Пронумеровать\". Сделали ошибку? Нажмите \"Заново\".",
  "projects.numbering.id.block.second": "Отредактируйте # юнита в ячейках",
  "projects.numbering.id.block.second.text": "Второе поле ввода можно редактировать. Убедитесь, что у каждого юнита уникальный номер.",
  "projects.numbering.id.floor": "Этаж",
  "projects.numbering.id.tower.corresponds": "соответств. башне B1, этажу #2, юниту #3",
  "projects.numbering.id.tower.example": "Пример: B1-02-3",
  "projects.numbering.id.tower.first": "Задайте номера квартир",
  "projects.numbering.id.tower.first.text": "Используйте поля ввода над колонками. Далее эти значения будут использоваться при генерации id.",
  "projects.numbering.id.tower.second": "Задайте формат id",
  "projects.numbering.id.tower.second.text": "Вы можете отредактировать значения, если желаете.",
  "projects.numbering.id.tower.tower": "Башня",
  "projects.numbering.id.unit": "Юнит",
  "projects.numbering.number.first": "# первого юнита",
  "projects.numbering.number.last": "# последнего юнита",
  "projects.numbering.number.split": "Нумеровать только первый из разделенных юнитов",
  "projects.numbering.pass": "Сквозная",
  "projects.numbering.skip.commercial": "Пропускать коммерческие",
  "projects.numbering.title": "Нумерация",
  "projects.page.add.new.building": "Добавить многоэтажное здание / очередь",
  "projects.page.add.new.project": "+ Добавить новый проект",
  "projects.page.add.new.project.popup.title": "Новый проект",
  "projects.page.add.new.villas": "Добавить паркоместа / коморы / частную застройку",
  "projects.page.edit.prices": "Изменить цены",
  "projects.page.edit.units": "Изменить юниты",
  "projects.page.no.projects": "Проектов еще нет",
  "projects.page.popup.add.block": "Добавить блок",
  "projects.page.popup.add.section": "Добавить секцию",
  "projects.page.popup.blocks": "Блоки",
  "projects.page.popup.completion": "Сдача",
  "projects.page.popup.edit.title": "Редактирование",
  "projects.page.popup.sections": "Секции",
  "projects.page.popup.start.of.sales": "Начало продаж:",
  "projects.page.popup.status": "Статус",
  "projects.page.popup.successfully.created": "Успешно создано!",
  "projects.page.popups.add.block": "Добавить",
  "projects.page.popups.add.building": "Добавить здание",
  "projects.page.popups.add.section": "Добавить",
  "projects.page.popups.block.index": "Название",
  "projects.page.popups.block.index.placeholder": "Цифра, буква...",
  "projects.page.popups.building.name": "Название здания",
  "projects.page.popups.building.name.placeholder": "Дом #1, ЖК Кристалл...",
  "projects.page.popups.contact.page": "Ссылка на страницу контактов",
  "projects.page.popups.description.page": "Ссылка на описание",
  "projects.page.popups.if.diff": "если отличается от адреса проекта...",
  "projects.page.popups.project.city": "Город",
  "projects.page.popups.project.city.placeholder": "Токио, Нью-Йорк...",
  "projects.page.popups.project.country": "Страна",
  "projects.page.popups.project.create": "Создать проект",
  "projects.page.popups.project.location": "Адрес",
  "projects.page.popups.project.location.placeholder": "улица, номер дома...",
  "projects.page.popups.project.name": "Название проекта",
  "projects.page.popups.project.name.placeholder": "Кристальный квартал, ЖК Первый...",
  "projects.page.popups.section.index": "Название",
  "projects.page.popups.villas.blocks": "Блоки",
  "projects.page.popups.villas.create.holder": "Создать контейнер",
  "projects.page.popups.villas.holder.name": "Название контейнера для вилл",
  "projects.page.popups.villas.holder.name.placeholder": "Виллы и участки...",
  "projects.page.sheets.step1.create.btn": "Создать таблицу",
  "projects.page.sheets.step1.create.text": "Или создайте таблицу-шаблон на новую дату.",
  "projects.page.sheets.step1.drafts": "Черновики",
  "projects.page.sheets.step1.hint": "Чтобы мы могли создать правильные колонки, пожалуйста, укажите запланированную дату изменения цен.",
  "projects.page.sheets.step1.li1": "изменить цены на все или некоторые юниты",
  "projects.page.sheets.step1.li2": "повысить/снизить цену на определенный процент или сумму",
  "projects.page.sheets.step1.li3": "округлить цену до цифры кратной 10, 100, 1000",
  "projects.page.sheets.step1.subtitle": "При помощи таблицы вы сможете:",
  "projects.page.sheets.step1.title": "Шаг 1. Формируем таблицу-шаблон",
  "projects.page.sheets.step1.unitsData.li1": "задать площади (общая, жилая, кухня)",
  "projects.page.sheets.step1.unitsData.li2": "задать комнатность",
  "projects.page.sheets.step1.unitsData.li3": "задать нумерацию",
  "projects.page.sheets.step1.unitsData.li4": "изменить тип юнита",
  "projects.page.sheets.step1.unitsData.li5": "задать тип планировки",
  "projects.page.sheets.step1.unitsData.li6": "задать государственный идентификатор",
  "projects.page.sheets.step2.cancel.btn": "Отменить и удалить таблицу",
  "projects.page.sheets.step2.cancel.btn.toast": "Таблица-черновик удалена!",
  "projects.page.sheets.step2.import.btn": "Загрузить таблицу в EstOffice",
  "projects.page.sheets.step2.import.btn.toast": "Успешно загружено!",
  "projects.page.sheets.step2.import.error": "Ошибка при импорте. Пожалуйста, исправьте некорректные данные и повторите импорт.",
  "projects.page.sheets.step2.title": "Шаг 2. Редактирование таблицы",
  "projects.page.sheets.step2.when.finished": "Когда закончите – загрузите заполненную таблицу.",
  "projects.page.sheets.step2.you.can.edit": "Вы можете редактировать значения в колонках, которые отмечены активным оранжевым цветом.",
  "projects.page.units.noprice": "Юнитов без цены:",
  "projects.price.prices": "Цены",
  "projects.price.unique.1part": "Если у каждой квартиры уникальная цена за кв.м. – используйте другой метод. Откройте эту",
  "projects.price.unique.2part": "Скопируйте из своего реестра цены квартир первого этажа и вставьте в первую колонку. Формула создаст строку цен, разделенных пробелами. Теперь вставьте данную строку в первую ячейку первого этажа. Повторите эти действия для всех этажей здания.",
  "projects.price.unique.link": "Google Таблицу",
  "projects.progress.area": "Площадь",
  "projects.progress.basic": "Основа",
  "projects.progress.features": "Особенности",
  "projects.progress.images": "Изображения",
  "projects.progress.num": "Нумерация",
  "projects.progress.price": "Цены",
  "projects.progress.published": "Опубликована",
  "projects.progress.review": "Проверка",
  "projects.progress.rooms": "Комнаты",
  "projects.review.public.view.tip": "Управляйте доступом к секции в разделе «Публичное отображение и план» на экране",
  "projects.review.public.view.tip.projects": "Проекты",
  "projects.review.publishing.status": "Статус опубликованности",
  "projects.review.publishing.status.draft": "Черновик",
  "projects.review.publishing.status.published": "Опубликована",
  "projects.review.publishing.status.unknown": "Нет данных",
  "projects.review.quick.status": "Быстрое изменение статусов",
  "projects.review.quick.status.booked": "Забронирован",
  "projects.review.quick.status.free": "Свободен",
  "projects.review.quick.status.notinstock": "Не в продаже",
  "projects.review.quick.status.sold": "Продан",
  "projects.review.save": "Сохранить",
  "projects.review.save.modal.draft.content": "Менеджеры по продаже не будут видеть данную секцию.",
  "projects.review.save.modal.draft.title": "Сохранено как черновик",
  "projects.review.save.modal.published.content": "Секция опубликована для бронирования и продажи.",
  "projects.review.save.modal.published.title": "Опубликовано",
  "projects.review.text": "Проверьте всю информацию. Вы можете вернуться к любой из стадий, если требуются изменения.",
  "projects.review.title": "Проверка и публикация",
  "projects.rooms.commercial": "Коммерческих",
  "projects.rooms.set.text": "Введите 1, 2, 3 для каждого юнита. Чтобы задать общее значение для столбца, используйте поле ввода над каждой из колонок.",
  "projects.rooms.set.title": "Задайте количество жилых комнат",
  "projects.rooms.statistics": "Статистика",
  "projects.rooms.total": "Всего",
  "projects.set.all.unit.type": "Установите тип всех юнитов",
  "projects.unit.type.apt": "Квартира",
  "projects.unit.type.commercial": "Коммерч.",
  "projects.unit.type.plot": "Участок",
  "projects.unit.type.villa": "Вилла",
  "reports.page.byprojects.all.time": "За все время",
  "reports.page.byprojects.annual": "Годовой отчет",
  "reports.page.byprojects.deals.full": "по 100% оплате",
  "reports.page.byprojects.deals.value.total": "Доход",
  "reports.page.byprojects.deals.value.total.mln": "доход, млн",
  "reports.page.byprojects.monthly": "Отчет за месяц",
  "reports.page.byprojects.nodata": "Нет данных",
  "reports.page.byprojects.weekly": "Отчет за неделю",
  "reports.page.dashboard.active.leads": "лидов с целевым действием",
  "reports.page.dashboard.created": "создали новых",
  "reports.page.dashboard.data.updated": "Обновление данных:",
  "reports.page.dashboard.day": "За день",
  "reports.page.dashboard.deals": "сделок",
  "reports.page.dashboard.deals.value": "сумма по сделкам",
  "reports.page.dashboard.interacted": "взаимодействовали",
  "reports.page.dashboard.interests": "интересов",
  "reports.page.dashboard.last": "Последние",
  "reports.page.dashboard.month": "За месяц",
  "reports.page.dashboard.new.leads": "новые лиды",
  "reports.page.dashboard.percentage.tooltip": "по сравнению с предыдущим периодом",
  "reports.page.dashboard.q1": "Кто лидирует в обработке лидов?",
  "reports.page.dashboard.q1.tip": "Сумма дневных значений менеджеров. Чем больше сумма – тем больше лидов менеджер обработал за эти 30/90 дней. Учитываются такие типы взаимодействия: заметки, задачи, звонки, изменение значений дополнительных полей.",
  "reports.page.dashboard.q2": "В какие дни велась наиболее активная работа?",
  "reports.page.dashboard.q2.tip": "Показывает количество добавленных и обновленных лидов в день. Если две точки совпадают, значит в этот день работа велась только с новыми лидами.",
  "reports.page.dashboard.reservations": "броней",
  "reports.page.dashboard.updated.leads": "лиды с прямым взаимодействием",
  "reports.page.dashboard.week": "За 7 дней",
  "reports.page.dashboard.year": "За год",
  "reports.page.filter.all.projects": "Все проекты",
  "reports.page.lead.working.q1": "Средний срок пребывания в текущем статусе",
  "reports.page.lead.working.q1.tip": "Статусы в этом графике относятся к воронке продаж. Поэтому ожидается, что лиды будут двигаться по воронке, а не застрявать в статусе на много дней.",
  "reports.page.menu.employee.all": "Все сотрудники",
  "reports.page.menu.employee.sales": "Продажи по сотрудникам",
  "reports.page.menu.stock.analysis": "Ассортимент",
  "reports.page.sales.by.time.count": "количество",
  "reports.page.sales.by.time.income": "доход",
  "reports.page.sales.by.time.months": "по месяцам",
  "reports.page.sales.by.time.sqm": "в кв.м.",
  "reports.page.sales.by.time.value": "стоимость",
  "reports.page.sales.by.time.weeks": "по неделям",
  "reports.page.sidebar.byprojects": "Сводка по проектам",
  "reports.page.sidebar.dashboard": "Сводка",
  "reports.page.sidebar.export.data": "Экспорт данных",
  "reports.page.sidebar.intervals": "День, месяц, год",
  "reports.page.sidebar.lead.working": "Проработка лидов",
  "reports.page.sidebar.leads.by.status": "Лиды сотрудников по статусам",
  "reports.page.sidebar.projects.alltime": "Продажи во времени",
  "reports.page.stock.analysis.q1": "Есть ли у нас что продавать на текущий момент?",
  "reports.page.stock.analysis.q1.tip": "в отчет включены только юниты, для которых указана общая площадь",
  "reports.page.stock.analysis.q2": "Насколько то, что у нас в ассортименте, востребованно? Есть ли у нас залежавшийся товар?",
  "reports.page.stock.analysis.q2.tip": "в расчет берутся только свободные и забронированные юниты",
  "reports.page.stock.analysis.q3": "Квартиры каких типов сейчас в наличии?",
  "settings.document.templates.title": "Шаблоны документов",
  "settings.opportunity.labels.title": "Стадии и статусы",
  "settings.page.customizations.custom.table.name": "Название",
  "settings.page.customizations.custom.type.choice": "Выбор",
  "settings.page.customizations.custom.type.date": "Дата",
  "settings.page.customizations.custom.type.number": "Число",
  "settings.page.customizations.custom.type.text": "Текст",
  "settings.page.customizations.customizations": "Настройки компании",
  "settings.page.customizations.default.currency": "Валюта по-умолчанию",
  "settings.page.customizations.land.measure": "Единица измерения земельных участков",
  "settings.page.customizations.lead.statuses": "Статусы лидов",
  "settings.page.customizations.lead.statuses.placeholder": "Название статуса...",
  "settings.page.customizations.lead.statuses.separator": "+ Добавить группу",
  "settings.page.customizations.menu.appeal.sources": "Источники обращений",
  "settings.page.customizations.menu.custom.fields": "Дополнительные поля",
  "settings.page.customizations.menu.customizations": "Настройки",
  "settings.page.customizations.menu.embed": "Добавить на сайт",
  "settings.page.customizations.menu.integrations": "Интеграции",
  "settings.page.customizations.menu.loans": "Рассрочки",
  "settings.page.customizations.menu.requests": "Обращения",
  "settings.page.customizations.menu.stacking.plan": "Шахматка",
  "settings.page.customizations.menu.users": "Сотрудники",
  "settings.page.customizations.price.lists": "Прайс-листы",
  "settings.page.customizations.price.lists.begin": "Дата начала",
  "settings.page.customizations.price.lists.end": "Дата окончания",
  "settings.page.customizations.price.lists.name": "Название",
  "settings.page.customizations.price.lists.parent": "На основе",
  "settings.page.customizations.time.zone": "Часовой пояс",
  "settings.page.customizations.unit.features": "Особенности юнитов",
  "settings.page.customizations.unit.features.abbr.placeholder": "Аббревиатура...",
  "settings.page.customizations.unit.features.name.placeholder": "Особенность...",
  "settings.page.customizations.unit.features.table.abbr": "Аббр.",
  "settings.page.customizations.unit.features.table.name": "Название",
  "settings.page.customizations.unit.status.cant.delete_1": "Количество юнитов с этим статусом:",
  "settings.page.customizations.unit.status.cant.delete_2": "Установите новый статус взамен удаляемого.",
  "settings.page.customizations.unit.status.confirm.delete": "Пожалуйста подтвердите удаление статуса",
  "settings.page.customizations.unit.statuses": "Статусы юнитов",
  "settings.page.customizations.unit.statuses.placeholder": "Название статуса...",
  "settings.page.customizations.unit.statuses.remove": "Удаление статуса юнита",
  "settings.page.customizations.unit.statuses.type.booked": "Бронь",
  "settings.page.customizations.unit.statuses.type.free": "Свободные",
  "settings.page.customizations.unit.statuses.type.notinstock": "Не в продаже",
  "settings.page.customizations.unit.statuses.type.sold": "Проданные",
  "settings.page.users.deactivated.at": "Деактивировано",
  "settings.page.users.modal.name": "Фамилия и Имя",
  "settings.page.users.modal.name.caution": "Пожалуйста, не сокращайте имя или фамилию.",
  "settings.page.users.modal.name.placeholder": "напишите фамилию и имя полностью",
  "settings.page.users.modal.note": "Заметка",
  "settings.page.users.modal.password": "Пароль",
  "settings.page.users.modal.role": "Роль",
  "settings.page.users.modal.title.newuser": "Новый сотрудник",
  "settings.page.users.modal.title.update": "Обновление сотрудника",
  "settings.page.users.title.active": "Активные",
  "settings.page.users.title.deactivated": "Деактивированные",
  "svg.upload.draft_plan_image_hint": "Загрузите изображение, на котором обозначены границы секций и их названия. Создайте все секции в EstOffice.",
  "svg.upload.draft_plan_image_label": "Схема разметки",
  "svg.upload.format.error": "Структура svg-файлуа, которий ви загрузили, не корректна.  Напишите в чат техподдержки, чтобы получить помощь.",
  "svg.upload.house.public.view.and.plan": "Публичное отображение и план",
  "svg.upload.navi_link_label": "Ссылка на интерактивный план:",
  "svg.upload.preview_image_label": "Финальное изображение",
  "svg.upload.published_navi": "Опубликованная разметка",
  "svg.upload.section_published_flag": "опубликовано",
  "svg.upload.sections.status.tip": "Если ничего не выбрано, все опубликованные секции будут доступны в публичном отображении.",
  "svg.upload.sections.status.title": "Публичный статус секций",
  "svg.upload.source_image_hint": "Высокое разрешение, горизонтальная ориентация, на изображении должно быть хорошо видно каждую из секций.",
  "svg.upload.source_image_label": "Исходное изображение",
  "svg.upload.success": "SVG-файл успешно загружено",
  "svg.upload.svg_file_label": "Размеченный SVG-файл",
  "svg.upload.title": "Публичное отображение",
  "toast.lead.was.added": "Лид добавлен в работу!",
  "unit.info.room": "комн.",
  "unit.popup.add": "+ Добавить",
  "unit.popup.add.url": "+ Телефон, email или ссылка",
  "unit.popup.apartment": "квартира",
  "unit.popup.attic": "мансарда",
  "unit.popup.cancel": "Отмена",
  "unit.popup.change.params.edit.area": "Изменение площади",
  "unit.popup.change.params.edit.auto.exchange.rate": "Автоматический курс",
  "unit.popup.change.params.edit.cost": "Стоимость юнита",
  "unit.popup.change.params.edit.exchange.rate": "Курс валюты",
  "unit.popup.change.params.edit.for.1usd": "за 1 USD",
  "unit.popup.change.params.edit.per.sqm": "Цена за кв.м.",
  "unit.popup.change.params.edit.price": "Изменение цены",
  "unit.popup.change.params.edit.price.per.meter": "задать цену за кв.м.",
  "unit.popup.change.params.edit.price.per.unit": "задать стоимость юнита",
  "unit.popup.change.params.title": "Изменить площадь и цену",
  "unit.popup.comment": "Комментарий",
  "unit.popup.comment.placeholder": "комментарий о лиде",
  "unit.popup.commercial.unit": "коммерческое",
  "unit.popup.contact": "Контакт",
  "unit.popup.cottage": "коттедж",
  "unit.popup.custom.fields": "Дополнительные поля",
  "unit.popup.duplex": "дуплекс",
  "unit.popup.email": "Email",
  "unit.popup.hotel.type": "апартаменты",
  "unit.popup.land.plot": "земельный участок",
  "unit.popup.meter": "м",
  "unit.popup.name": "Имя",
  "unit.popup.name.placeholder": "Имя Фамилия",
  "unit.popup.noname": "Без имени",
  "unit.popup.none": "Нет",
  "unit.popup.note.long": "Заметка в Историю",
  "unit.popup.parking.lot": "паркоместо",
  "unit.popup.pavement.parking": "стояночное место",
  "unit.popup.payment.type.deposit": "Депозит",
  "unit.popup.payment.type.fine": "Платеж по штрафу",
  "unit.popup.payment.type.first": "Первый платеж",
  "unit.popup.payment.type.other": "Другой платеж",
  "unit.popup.payment.type.periodical": "Периодический платеж",
  "unit.popup.payment.type.refund": "Возврат денег",
  "unit.popup.phone": "Телефон",
  "unit.popup.save": "OK",
  "unit.popup.store.room": "кладовка",
  "unit.popup.townhouse": "таунхаус",
  "unit.popup.unitdeallead.integration.contact": "контакт",
  "unit.popup.unitdeallead.integration.deal": "сделка",
  "unit.popup.unitdeallead.integration.units": "юниты",
  "unit.popup.unitdeallead.payment.select.no": "Нет",
  "unit.popup.unitdeallead.payment.select.one": "Каждый месяц",
  "unit.popup.unitdeallead.payment.select.three": "Раз в квартал",
  "unit.popup.unitdeallead.payment.select.two": "Раз в два месяца",
  "unit.popup.unitdeallead.payment.select.yes": "Да",
  "unit.popup.url": "телефон, email или ссылка",
  "unit.popup.villa": "вилла",
  "unit.popup.work_with_lead.in_proposal": "В предложении",
  "unit.search.found.total.in.project": "Найдено <b>{{ total }}</b> квартир в <b>{{ name }}</b>",
  "unit.search.open.filters": "Открыть фильтры",
  "unit.search.show.other.project.results": "Смотреть в других ЖК ({{ total }})",
  "unit.search.show.results": "Показать результаты",
  "units.page.add.lead.mobile": "Добавить лида с мобильного",
  "units.page.filters": "Фильтры",
  "units.page.filters.show": "показать фильтры",
  "units.page.noresults.neighbours.close": "близкое совпадение",
  "units.page.noresults.neighbours.exact": "точное совпадение",
  "units.page.noresults.reset": "Сбросить фильтр",
  "units.page.nounits": "Шахматка еще не создана",
  "units.page.parking": "Паркинг",
  "units.page.print.booked.reserved": "бронь, резерв",
  "units.page.print.stacking.plan.by": "Шахматка EstOffice от",
  "units.page.results.in.section": "Найдено в секции",
  "units.page.search.panel.close.settings": "Вернуться к фильтрам",
  "units.page.search.panel.display": "Отображение",
  "units.page.search.panel.display.house": "по зданиям/очередям",
  "units.page.search.panel.display.section": "по секциям",
  "units.page.search.panel.from": "от",
  "units.page.search.panel.price": "Стоимость",
  "units.page.search.panel.price1sqm": "Цена 1 кв.м.",
  "units.page.search.panel.prices": "Цены",
  "units.page.search.panel.reset": "Сбросить",
  "units.page.search.panel.rooms": "Комнаты",
  "units.page.search.panel.status": "Статусы",
  "units.page.search.panel.to": "до",
  "units.page.search.panel.view": "Вид",
  "units.page.search.panel.view.fullsize": "полный вид",
  "units.page.search.panel.view.hide.sold": "прятать проданные",
  "units.page.search.panel.view.minimize": "компактный вид",
  "units.page.search.panel.view.show.sold": "показывать проданные",
  "units.page.search.panel.view.standard": "стандартный вид",
  "units.page.section": "Секция",
  "units.page.sidebar.all.photos": "все фото",
  "units.page.sidebar.object": "Здание в выбранном проекте",
  "units.page.sidebar.open": "перейти",
  "units.page.sidebar.project": "Проект",
  "units.page.sidebar.public.link": "Публичная ссылка",
  "units.page.sidebar.quarter": "кв",
  "units.page.sidebar.sections": "Секции / блоки / группы",
  "units.page.storey": "этаж",
  "working.with.filters.modal.title": "Сохранить фильтры",
  "working.with.filters.save.error": "Не удалось сохранить фильтры",
  "working.with.filters.saved": "Фильтры сохранены",
  "working.with.link.copied": "Ссылка скопирована",
  "working.with.link.copy.error": "Не удалось скопировать ссылку"
});

$translateProvider.translations("uk", {
  "button.choose_file": "Оберіть файл",
  "button.close": "Закрити",
  "button.preview": "Попередній перегляд",
  "button.publish": "Опублікувати",
  "general.add": "Додати",
  "general.button.export": "Експорт",
  "general.button.next": "Далі",
  "general.copied": "Скопійовано!",
  "general.copy": "скопіювати",
  "general.current.lang": "uk",
  "general.edit.title": "Редагування",
  "general.filters.add": "Оберіть...",
  "general.filters.between": "Діапазон...",
  "general.filters.date.after": "Після ...",
  "general.filters.date.before": "До ...",
  "general.filters.date.before.30": "Більше місяця тому",
  "general.filters.date.before.7": "Більше тижня тому",
  "general.filters.date.month": "За місяць...",
  "general.filters.date.on": "Точна дата...",
  "general.filters.date.on.short": "дата",
  "general.filters.date.today": "Сьогодні",
  "general.filters.date.within.30": "За останні 30 днів",
  "general.filters.date.within.7": "За останні 7 днів",
  "general.filters.date.yesterday": "Вчора",
  "general.filters.exactly": "Дорівнює ...",
  "general.filters.has.no": "Немає",
  "general.filters.has.yes": "Є",
  "general.filters.hit.enter": "натисніть enter",
  "general.filters.less": "Менше ...",
  "general.filters.more": "Більше ...",
  "general.gallery.upload": "+ Завантажити",
  "general.link": "лінк",
  "general.modal.are.you.sure": "Ви впевнені?",
  "general.modal.doesnt.work.message": "Якщо Ви хочете цю функціональність, напишіть нам на support@estoffice.com.",
  "general.modal.doesnt.work.title": "Поки що не працює",
  "general.modal.got.it": "OK",
  "general.month.april": "Квітень",
  "general.month.august": "Серпень",
  "general.month.december": "Грудень",
  "general.month.february": "Лютий",
  "general.month.january": "Січень",
  "general.month.july": "Липень",
  "general.month.june": "Червень",
  "general.month.march": "Березень",
  "general.month.may": "Травень",
  "general.month.november": "Листопад",
  "general.month.october": "Жовтень",
  "general.month.september": "Вересень",
  "general.months": "міс.",
  "general.saving": "Зберігаємо...",
  "general.search.not.found": "Збігів не знайдено",
  "general.search.placeholder": "Пошук ...",
  "general.update": "Зберегти",
  "general.working.with": "В роботі",
  "lead.popup.area": "Площа",
  "lead.popup.expires.days": "д.",
  "lead.popup.expires.days.full": "днів",
  "lead.popup.expires.leads.full": "лидов",
  "lead.popup.links.room": "-кімн.",
  "lead.popup.links.sqm": "кв.м.",
  "lead.popup.num": "Номер",
  "leads.buttons.add.note": "Додати нотатку",
  "leads.buttons.bulk.edit": "Групова дія",
  "leads.buttons.bulk.note.adding": "Групова нотатка",
  "leads.buttons.bulk.note.update": "Додати до",
  "leads.buttons.bulk.note.with.note": "лідам нотатку",
  "leads.buttons.bulk.status.change": "Групова зміна статусу",
  "leads.buttons.bulk.status.change.status.of": "Змінити статус",
  "leads.buttons.bulk.status.leads.to": "лідів на",
  "leads.buttons.change.status": "Змінити статус",
  "leads.buttons.sort": "Сортування",
  "leads.buttons.sort.date.updated": "Дата оновлення",
  "leads.buttons.sort.lead.status": "Статус ліда",
  "leads.mobile.add.from.clipboard": "Вставте телефон з буфера обміну",
  "leads.mobile.add.long.tap": "тривалий дотик",
  "leads.mobile.add.toast.msg": "Нового ліда було створено!",
  "leads.search.create.new": "Новий лід",
  "leads.search.create.new.appeal.source": "Джерело звернення",
  "leads.search.create.new.disabled.tooltip": "Обов'язкові поля незаповнені",
  "leads.search.create.new.items": "Зміст запиту",
  "leads.search.create.new.newlead": "Новий лід",
  "leads.search.create.new.projects": "Проєкти",
  "leads.search.create.new.save.and.add.to.clipboard": "Зберегти і підібрати квартири",
  "leads.search.create.new.save.lead": "Зберегти ліда",
  "leads.search.create.new.segmentation": "Сегментація",
  "leads.search.create.new.status.tooltip": "Виберіть статус ліда ...",
  "leads.search.records": "ліди",
  "leads.search.tab.tooltip": "Натискання tab активує дане поле",
  "leads.sidebar.filter.and.work": "Фільтрація",
  "leads.sidebar.lead.action": "Дії лідів",
  "leads.sidebar.lead.has.email": "Наявність email",
  "leads.sidebar.lead.has.note": "Наявність нотатки про Ліда",
  "leads.sidebar.lead.has.phone": "Наявність телефону",
  "leads.sidebar.lead.has.task": "Наявність завдань у Ліда",
  "leads.sidebar.lead.items.interest": "Суть запиту",
  "leads.sidebar.lead.items.interest.1r": "1 к",
  "leads.sidebar.lead.items.interest.2r": "2к",
  "leads.sidebar.lead.items.interest.3r": "3к",
  "leads.sidebar.lead.items.interest.ground": "цоколь",
  "leads.sidebar.lead.items.interest.ready": "зданий",
  "leads.sidebar.lead.items.interest.studio": "студія",
  "leads.sidebar.lead.project": "Проект",
  "leads.sidebar.lead.record": "Інформація про лідів",
  "leads.sidebar.lead.status": "Статус",
  "leads.sidebar.main.what": "Дія",
  "leads.sidebar.main.what.reservation.options": "Деталі про бронювання",
  "leads.sidebar.main.what.reservation.options.duration": "Тривалість",
  "leads.sidebar.main.what.reservation.options.expiration": "Дата зняття",
  "leads.sidebar.main.what.reservation.options.status": "Статус",
  "leads.sidebar.main.when": "Дата",
  "leads.sidebar.main.where": "Дія відноситься до ...",
  "leads.sidebar.main.where.floor.area": "Площа",
  "leads.sidebar.main.where.rooms": "Кількість кімнат",
  "leads.sidebar.main.where.sections": "Секції",
  "leads.sidebar.main.where.storey": "Поверх",
  "leads.sidebar.main.where.type": "Тип юніта",
  "leads.sidebar.main.where.type.group.individual": "Індивідуальна забудова",
  "leads.sidebar.main.where.type.group.main": "Житло та коммерція",
  "leads.sidebar.main.where.type.group.other": "Інше",
  "leads.sidebar.main.where.unique.id": "Унікальний ID юніта",
  "leads.sidebar.main.who": "Співробітник, який вніс",
  "leads.sidebar.notes": "Нотатки до лідів",
  "leads.sidebar.notes.content": "Текст нотатки",
  "leads.sidebar.notes.date": "Дата нотатки",
  "leads.sidebar.notes.has.notes": "Наявність нотаток",
  "leads.sidebar.notes.quantity": "Кількість",
  "leads.sidebar.only.leads": "Тільки ліди",
  "leads.sidebar.only.my.leads": "Тільки мої",
  "leads.sidebar.select.created": "Дата створення",
  "leads.sidebar.select.note.user": "Співробітник, який додав нотатку",
  "leads.sidebar.select.price.1sqm": "Ціна кв.м.",
  "leads.sidebar.select.price.total": "Вартість юніта",
  "leads.sidebar.select.reservation.status.active": "Активна",
  "leads.sidebar.select.reservation.status.inactive": "Вже знято",
  "leads.sidebar.select.total.area": "Загальна площа",
  "leads.sidebar.select.updated": "Дата оновлення",
  "leads.sidebar.select.what.booked": "Забронював",
  "leads.sidebar.select.what.canceled.deal": "Скасував угоду",
  "leads.sidebar.select.what.extended.reservation": "Продовжив бронь",
  "leads.sidebar.select.what.interested": "Цікавився",
  "leads.sidebar.select.what.purchased": "Купив",
  "leads.sidebar.select.what.updated.deal": "Змінив угоду",
  "leads.sidebar.smart.tasks": "Smart-завдання",
  "leads.sidebar.smart.tasks.everyday": "кожен день",
  "leads.sidebar.smart.tasks.once": "кожну середу",
  "leads.sidebar.smart.tasks.twice": "у вівторок і п'ятницю",
  "leads.sidebar.unit.status": "Статус юніта",
  "leads.sidebar.user.created": "Співробітник, який створив",
  "leads.sidebar.user.updated": "Співробітник, який оновив",
  "leads.table.created.at": "Дата створення",
  "leads.table.created.by": "Хто створив",
  "leads.table.ibp": "Запит / Інтерес / Бронь / Купив",
  "leads.table.last.action": "Остання дія",
  "leads.table.updated.by": "Хто оновив",
  "navi.all_sold": "Все продано",
  "navi.area": "Площа",
  "navi.button": "план",
  "navi.in_stock": "У продажу",
  "navi.incoming": "Скоро у продажу",
  "navi.modal.back": "Назад",
  "navi.modal.title": "Інтерактивний план",
  "navi.not_in_stock": "Немає у продажу",
  "navi.num.of.storeys": "Поверховість",
  "navi.price.from": "Ціна від",
  "navi.price.per.m": "м",
  "navi.publish.error": "Помилка при публікації навігації",
  "navi.publish.preview": "Попередній перегляд",
  "navi.publish.success": "Інтерактивна навігація була опублікована",
  "navi.return.to.navi": "Назад до генплану",
  "navi.scroll.horizontally": "скрольте горизонтально",
  "navi.section.class": "Клас",
  "navi.sold.out": "Всі квартири продано",
  "objects.navi.panel.group.see_also": "Дивіться також",
  "objects.navi.panel.group.selected": "Обрані",
  "projects.area.fill": "Задати",
  "projects.area.kitchen": "Кухня",
  "projects.area.living": "Житлова",
  "projects.area.plot.size": "Задати",
  "projects.area.set.commercial": "Площа комерційних приміщень",
  "projects.area.set.plot": "Площа земельних ділянок",
  "projects.area.set.text": "Загальна площа потрібна для обчислення вартості юнітів. Площа кухні і житлова площа - не обов'язкові для заповнення.",
  "projects.area.set.title": "Задайте площі приміщень",
  "projects.area.show.all": "Показати всі три",
  "projects.area.total": "Загальна",
  "projects.basic.basement": "Нульовий поверх",
  "projects.basic.bind_to_single_floor": "Прив'язати до одного поверху",
  "projects.basic.commercial": "Комерційні площі",
  "projects.basic.completed": "Здано в експлуатацію",
  "projects.basic.completion.date": "Дата здачі",
  "projects.basic.completion.date.unset": "в проекті",
  "projects.basic.construction": "Будується",
  "projects.basic.construction.stage": "Стадія готовності",
  "projects.basic.create": "Створити юніти",
  "projects.basic.create.check": "Перевірте! Надалі Ви не зможете змінити ці налаштування.",
  "projects.basic.create.cta": "Створіть юніти",
  "projects.basic.floor_override": "Номер поверху",
  "projects.basic.grid.edit": "Редагування сітки",
  "projects.basic.grid.params": "Параметри сітки",
  "projects.basic.mark": "Позначити",
  "projects.basic.merge": "Об'єднати / Скасувати",
  "projects.basic.nounit": "Немає юніта",
  "projects.basic.parking": "Підземний паркінг",
  "projects.basic.per.storey": "Юнітів на поверсі",
  "projects.basic.split": "Розділити / Скасувати",
  "projects.basic.stage.completion": "Стадія і дата здачі",
  "projects.basic.storeys": "Поверхів",
  "projects.basic.units.horizontally": "По горизонталі",
  "projects.basic.units.vertically": "По вертикалі",
  "projects.features.custom.fields": "Додаткові поля",
  "projects.features.custom.fields.no": "У Вас немає жодного додаткового поля. Щоб додати, перейдіть у Налаштування.",
  "projects.features.features": "Особливості",
  "projects.features.helptext.1part": "Щоб застосувати додаткове значення до всіх юнитам натисніть",
  "projects.features.helptext.2part": "застосують додаткове значення або особливість до першого, другого і N-ного стовпчику відповідно.",
  "projects.images.all.units": "відноситься до всіх",
  "projects.images.floor.plans": "Плани поверхів",
  "projects.images.floor.plans.units": "Планування юнітів",
  "projects.images.linked.to": "Віднос. до",
  "projects.images.linked.to.units": "юнітам",
  "projects.images.master.plans": "Генплани",
  "projects.images.visual.units": "Візуалізації юнітів",
  "projects.numbering.button.autoset": "Нумерувати",
  "projects.numbering.button.startover": "Заново",
  "projects.numbering.id": "За id",
  "projects.numbering.id.block.block": "Блок",
  "projects.numbering.id.block.corresponds": "відповідає блоку B1, юніту #12",
  "projects.numbering.id.block.example": "Приклад: B1-12",
  "projects.numbering.id.block.first": "Задайте формат id",
  "projects.numbering.id.block.first.text": "Додавайте роздільники і свій текст, якщо потрібно. Потім натисніть \"Пронумерувати\". Зробили помилку? Натисніть \"Заново\".",
  "projects.numbering.id.block.second": "Відредагуйте # юніта в осередках",
  "projects.numbering.id.block.second.text": "Друге поле введення можна редагувати. Переконайтеся, що у кожного юніта унікальний номер.",
  "projects.numbering.id.floor": "Поверх",
  "projects.numbering.id.tower.corresponds": "відповідає вежі B1, поверху # 2, юніту # 3 ",
  "projects.numbering.id.tower.example": "Приклад: B1-02-3",
  "projects.numbering.id.tower.first": "Задайте номера квартир",
  "projects.numbering.id.tower.first.text": "Використовуйте поля введення над колонками. Далі ці значення будуть використовуватися при генерації id.",
  "projects.numbering.id.tower.second": "Задайте формат id",
  "projects.numbering.id.tower.second.text": "Ви можете відредагувати значення, якщо бажаєте.",
  "projects.numbering.id.tower.tower": "Вежа",
  "projects.numbering.id.unit": "Юніт",
  "projects.numbering.number.first": "# першого юніту",
  "projects.numbering.number.last": "# останнього юніту",
  "projects.numbering.number.split": "Нумерувати тільки перший з розділених юнітів",
  "projects.numbering.pass": "Наскрізна",
  "projects.numbering.skip.commercial": "Пропускати комерційні",
  "projects.numbering.title": "Нумерація",
  "projects.page.add.new.building": "Додати багатоповерховий будинок / чергу",
  "projects.page.add.new.project": "+ Додати новий проект",
  "projects.page.add.new.project.popup.title": "Новий проект",
  "projects.page.add.new.villas": "Додати паркомісця / комори / приватну забудову",
  "projects.page.edit.prices": "Редагувати ціни",
  "projects.page.edit.units": "Редагувати юніти",
  "projects.page.no.projects": "Проектів ще немає",
  "projects.page.popup.add.block": "Додати блок",
  "projects.page.popup.add.section": "Додати секцію",
  "projects.page.popup.blocks": "Блоки",
  "projects.page.popup.completion": "Введення в експ.",
  "projects.page.popup.edit.title": "Редагування",
  "projects.page.popup.sections": "Секції",
  "projects.page.popup.start.of.sales": "Початок продажів:",
  "projects.page.popup.status": "Статус",
  "projects.page.popup.successfully.created": "Успішно створено!",
  "projects.page.popups.add.block": "Додати",
  "projects.page.popups.add.building": "Додати будівлю",
  "projects.page.popups.add.section": "Додати",
  "projects.page.popups.block.index": "Назва",
  "projects.page.popups.block.index.placeholder": "Цифра, буква...",
  "projects.page.popups.building.name": "Назва будівлі",
  "projects.page.popups.building.name.placeholder": "Дім #1, ЖК Кристалл...",
  "projects.page.popups.contact.page": "Посилання на сторінку контактів",
  "projects.page.popups.description.page": "Посилання на опис",
  "projects.page.popups.if.diff": "якщо відрізняється від адреси проекту ...",
  "projects.page.popups.project.city": "Місто",
  "projects.page.popups.project.city.placeholder": "Токіо, Нью-Йорк...",
  "projects.page.popups.project.country": "Країна",
  "projects.page.popups.project.create": "Створити проект",
  "projects.page.popups.project.location": "Адреса",
  "projects.page.popups.project.location.placeholder": "вулиця, номер будинку...",
  "projects.page.popups.project.name": "Назва проекту",
  "projects.page.popups.project.name.placeholder": "Кришталевий квартал, ЖК Перший ...",
  "projects.page.popups.section.index": "Назва",
  "projects.page.popups.villas.blocks": "Блоки",
  "projects.page.popups.villas.create.holder": "Створити контейнер",
  "projects.page.popups.villas.holder.name": "Назва контейнера для вілл",
  "projects.page.popups.villas.holder.name.placeholder": "Вілли і ділянки ...",
  "projects.page.sheets.step1.create.btn": "Створити таблицю",
  "projects.page.sheets.step1.create.text": "Або створіть таблицю-шаблон на нову дату.",
  "projects.page.sheets.step1.drafts": "Чернетки",
  "projects.page.sheets.step1.hint": "Щоб ми могли створити правильні стовбці, будь-ласка, вкажіть заплановану дату зміни цін.",
  "projects.page.sheets.step1.li1": "змінити ціни на всі або деякі юніти",
  "projects.page.sheets.step1.li2": "підвищити/знизити ціну на певний відсоток або суму",
  "projects.page.sheets.step1.li3": "округлити ціну до цифри кратної 10, 100, 1000",
  "projects.page.sheets.step1.subtitle": "За допомогою таблиці ви зможете:",
  "projects.page.sheets.step1.title": "Крок 1. Формуємо таблицю-шаблон",
  "projects.page.sheets.step1.unitsData.li1": "задати площі (загальну, житлову, кухні)",
  "projects.page.sheets.step1.unitsData.li2": "задати кімнатність",
  "projects.page.sheets.step1.unitsData.li3": "задати нумерацію",
  "projects.page.sheets.step1.unitsData.li4": "змінити тип юніта",
  "projects.page.sheets.step1.unitsData.li5": "задати тип планування",
  "projects.page.sheets.step1.unitsData.li6": "задати державний ідентифікатор",
  "projects.page.sheets.step2.cancel.btn": "Відмінити та видалити таблицю",
  "projects.page.sheets.step2.cancel.btn.toast": "Таблицу-чернетку видалено!",
  "projects.page.sheets.step2.import.btn": "Завантажити таблицю в EstOffice",
  "projects.page.sheets.step2.import.btn.toast": "Успішно завантажено!",
  "projects.page.sheets.step2.import.error": "Помилка під час завантаження. Будь-ласка, виправте помилки у таблиці і повторіть.",
  "projects.page.sheets.step2.title": "Крок 2. Редагування таблиці",
  "projects.page.sheets.step2.when.finished": "По завершенню – завантажте заповнену таблицю.",
  "projects.page.sheets.step2.you.can.edit": "Вы можете редагувати відомості у стовбцях, що відмічено активним помаранчевим кольором.",
  "projects.page.units.noprice": "Юнітов без ціни:",
  "projects.price.prices": "Ціни",
  "projects.price.unique.1part": "Якщо у кожної квартири унікальна ціна за кв.м. - використовуйте інший метод. Відкрийте цю",
  "projects.price.unique.2part": "Скопіюйте зі свого реєстру ціни квартир першого поверху і вставте в першу колонку. Формула створить рядок цін, розділених пробілами. Тепер вставте цей рядок в перший осередок першого поверху. Повторіть ці дії для всіх поверхів будівлі.",
  "projects.price.unique.link": "Google Таблицю",
  "projects.progress.area": "Площа",
  "projects.progress.basic": "Основа",
  "projects.progress.features": "Особливості",
  "projects.progress.images": "Зображення",
  "projects.progress.num": "Нумерація",
  "projects.progress.price": "Ціни",
  "projects.progress.published": "Опублікована",
  "projects.progress.review": "Перевірка",
  "projects.progress.rooms": "Кімнати",
  "projects.review.public.view.tip": "Управляйте доступом до секції в розділі «Публічне відображення і план» на екрані",
  "projects.review.public.view.tip.projects": "Проєкти",
  "projects.review.publishing.status": "Статус опублікування",
  "projects.review.publishing.status.draft": "Чернетка",
  "projects.review.publishing.status.published": "Опублікована",
  "projects.review.publishing.status.unknown": "Немає даних",
  "projects.review.quick.status": "Швидка зміна статусів",
  "projects.review.quick.status.booked": "Заброньовано",
  "projects.review.quick.status.free": "Вільний",
  "projects.review.quick.status.notinstock": "Не продається",
  "projects.review.quick.status.sold": "Продано",
  "projects.review.save": "Зберегти",
  "projects.review.save.modal.draft.content": "Менеджери з продажу не бачитимуть цю секцію.",
  "projects.review.save.modal.draft.title": "Збережено як чернетку",
  "projects.review.save.modal.published.content": "Секція опублікована для бронювання та продажу.",
  "projects.review.save.modal.published.title": "Опубліковано",
  "projects.review.text": "Перевірте всю інформацію. Ви можете повернутися до будь-якої із стадій, якщо є необхідність щось змінити.",
  "projects.review.title": "Перевірка і публікація",
  "projects.rooms.commercial": "Комерційних",
  "projects.rooms.set.text": "Введіть 1, 2, 3 для кожного юніта. Щоб задати загальне значення для стовпця, використовуйте поле введення над кожною з колонок.",
  "projects.rooms.set.title": "Задайте кількість житлових кімнат",
  "projects.rooms.statistics": "Статистика",
  "projects.rooms.total": "Усього",
  "projects.set.all.unit.type": "Встановіть тип усіх юнітів",
  "projects.unit.type.apt": "Квартира",
  "projects.unit.type.commercial": "Комерц.",
  "projects.unit.type.plot": "Ділянка",
  "projects.unit.type.villa": "Вілла",
  "reports.page.byprojects.all.time": "За весь час",
  "reports.page.byprojects.annual": "Річний звіт",
  "reports.page.byprojects.deals.full": "Зі 100% оплатою",
  "reports.page.byprojects.deals.value.total": "Дохід",
  "reports.page.byprojects.deals.value.total.mln": "дохід, млн",
  "reports.page.byprojects.monthly": "Звіт за місяць",
  "reports.page.byprojects.nodata": "Немає даних",
  "reports.page.byprojects.weekly": "Звіт за тиждень",
  "reports.page.dashboard.active.leads": "лідів з цільовою дією",
  "reports.page.dashboard.created": "створили нових",
  "reports.page.dashboard.data.updated": "Оновлення даних:",
  "reports.page.dashboard.day": "За день",
  "reports.page.dashboard.deals": "угод",
  "reports.page.dashboard.deals.value": "сума за угодами",
  "reports.page.dashboard.interacted": "взаємодіяли",
  "reports.page.dashboard.interests": "інтересів",
  "reports.page.dashboard.last": "Останні",
  "reports.page.dashboard.month": "За місяць",
  "reports.page.dashboard.new.leads": "нові ліди",
  "reports.page.dashboard.percentage.tooltip": "в порівнянні з попереднім періодом",
  "reports.page.dashboard.q1": "Хто лідер з опрацювання лідів?",
  "reports.page.dashboard.q1.tip": "Сума добових показників менеджера. Чим більше сума – тим більше лідів менеджер опрацював за ці 30/90 днів. Враховуються наступні типи взаємодії: нотатки, завдання, дзвінки, зміна значень додаткових полів.",
  "reports.page.dashboard.q2": "В які дні відбувалась найбільш активна робота?",
  "reports.page.dashboard.q2.tip": "Показує кількість нових і оновлених лідів за день. Якщо дві точки співпадають, то в цей день опрацьовувались тільки нові ліди.",
  "reports.page.dashboard.reservations": "бронювань",
  "reports.page.dashboard.updated.leads": "ліди з прямою взаємодією",
  "reports.page.dashboard.week": "За 7 днів",
  "reports.page.dashboard.year": "За рік",
  "reports.page.filter.all.projects": "Всі проекти",
  "reports.page.lead.working.q1": "Середній строк перебування у поточному статусі",
  "reports.page.lead.working.q1.tip": "Статуси відносяться до воронки продажів. Тож ліди мають рухатись, а не застрягати у статусі на багато днів.",
  "reports.page.menu.employee.all": "Всі співробітники",
  "reports.page.menu.employee.sales": "Продажі по співробітникам",
  "reports.page.menu.stock.analysis": "Асортимент",
  "reports.page.sales.by.time.count": "кількість",
  "reports.page.sales.by.time.income": "дохід",
  "reports.page.sales.by.time.months": "по місяцях",
  "reports.page.sales.by.time.sqm": "в кв.м.",
  "reports.page.sales.by.time.value": "вартість",
  "reports.page.sales.by.time.weeks": "по тижнях",
  "reports.page.sidebar.byprojects": "Зведення за проектами",
  "reports.page.sidebar.dashboard": "Зведення",
  "reports.page.sidebar.export.data": "Експорт даних",
  "reports.page.sidebar.intervals": "День, місяць, рік",
  "reports.page.sidebar.lead.working": "Опрацювання лідів",
  "reports.page.sidebar.leads.by.status": "Ліди співробітників по статусах",
  "reports.page.sidebar.projects.alltime": "Продажі у часі",
  "reports.page.stock.analysis.q1": "Чи є у нас достатній асортимент на даний момент?",
  "reports.page.stock.analysis.q1.tip": "у звіт включено лише юніти, для яких вказано загальну площу",
  "reports.page.stock.analysis.q2": "Наскільки те, що у нас в ассортименті, затребуване? Чи є у нас залежаний товар?",
  "reports.page.stock.analysis.q2.tip": "в розрахунок беруться тільки вільні та зарезервовані юніти",
  "reports.page.stock.analysis.q3": "Квартири яких типів зараз в наявності?",
  "settings.document.templates.title": "Шаблони документів",
  "settings.opportunity.labels.title": "Стадії та статуси",
  "settings.page.customizations.custom.table.name": "Назва",
  "settings.page.customizations.custom.type.choice": "Вибір",
  "settings.page.customizations.custom.type.date": "Дата",
  "settings.page.customizations.custom.type.number": "Число",
  "settings.page.customizations.custom.type.text": "Текст",
  "settings.page.customizations.customizations": "Налаштування компанії",
  "settings.page.customizations.default.currency": "Основна валюта",
  "settings.page.customizations.land.measure": "Одиниця виміру земельних ділянок",
  "settings.page.customizations.lead.statuses": "Статуси лідів",
  "settings.page.customizations.lead.statuses.placeholder": "Назва статусу ...",
  "settings.page.customizations.lead.statuses.separator": "+ Додати групу",
  "settings.page.customizations.menu.appeal.sources": "Джерела звернень",
  "settings.page.customizations.menu.custom.fields": "Додаткові поля",
  "settings.page.customizations.menu.customizations": "Налаштування",
  "settings.page.customizations.menu.embed": "Додати на сайт",
  "settings.page.customizations.menu.integrations": "Інтеграції",
  "settings.page.customizations.menu.loans": "Розтермінування",
  "settings.page.customizations.menu.requests": "Звернення",
  "settings.page.customizations.menu.stacking.plan": "Шахматка",
  "settings.page.customizations.menu.users": "Співробітники",
  "settings.page.customizations.price.lists": "Прайс-листи",
  "settings.page.customizations.price.lists.begin": "Дата початку",
  "settings.page.customizations.price.lists.end": "Дата закінчення",
  "settings.page.customizations.price.lists.name": "Назва",
  "settings.page.customizations.price.lists.parent": "На основі",
  "settings.page.customizations.time.zone": "Часовий пояс",
  "settings.page.customizations.unit.features": "Особливості юнітів",
  "settings.page.customizations.unit.features.abbr.placeholder": "Абревіатура ...",
  "settings.page.customizations.unit.features.name.placeholder": "Особливість ...",
  "settings.page.customizations.unit.features.table.abbr": "Аббр.",
  "settings.page.customizations.unit.features.table.name": "Назва",
  "settings.page.customizations.unit.status.cant.delete_1": "Кількість юнітів з цим статусом:",
  "settings.page.customizations.unit.status.cant.delete_2": "Встановіть новий статус замість того що видаляється.",
  "settings.page.customizations.unit.status.confirm.delete": "Будь-ласка підвтердіть видалення статуса",
  "settings.page.customizations.unit.statuses": "Статуси юнітів",
  "settings.page.customizations.unit.statuses.placeholder": "Назва статусу ...",
  "settings.page.customizations.unit.statuses.remove": "Видалення статуса юніта",
  "settings.page.customizations.unit.statuses.type.booked": "Бронь",
  "settings.page.customizations.unit.statuses.type.free": "Вільні",
  "settings.page.customizations.unit.statuses.type.notinstock": "Не в продажу",
  "settings.page.customizations.unit.statuses.type.sold": "Продані",
  "settings.page.users.deactivated.at": "Деактивовано",
  "settings.page.users.modal.name": "Прізвище та ім'я",
  "settings.page.users.modal.name.caution": "Будь ласка, не скорочуйте ім'я або прізвище.",
  "settings.page.users.modal.name.placeholder": "напишіть прізвище та ім'я повністю",
  "settings.page.users.modal.note": "Нотатка",
  "settings.page.users.modal.password": "Пароль",
  "settings.page.users.modal.role": "Роль",
  "settings.page.users.modal.title.newuser": "Новий співробітник",
  "settings.page.users.modal.title.update": "Оновлення співробітника",
  "settings.page.users.title.active": "Активні",
  "settings.page.users.title.deactivated": "Деактивовані",
  "svg.upload.draft_plan_image_hint": "Завантажте зображення, на якому позначені межі секцій та їх назви. Створіть всі секції в EstOffice.",
  "svg.upload.draft_plan_image_label": "Схема розмітки",
  "svg.upload.format.error": "Структура svg-файлу, який ви завантажили, не коректна.  Напишіть в чат техпідтримки для отримання допомоги.",
  "svg.upload.house.public.view.and.plan": "Публічне відображення і план",
  "svg.upload.navi_link_label": "Посилання на інтерактивний план:",
  "svg.upload.preview_image_label": "Фінальне зображення",
  "svg.upload.published_navi": "Опублікована розмітка",
  "svg.upload.section_published_flag": "опубліковано",
  "svg.upload.sections.status.tip": "Якщо нічого не обрано, всі опубліковані секції будуть доступні у публічному відображенні.",
  "svg.upload.sections.status.title": "Публічний статус секцій",
  "svg.upload.source_image_hint": "Висока якість зображення, горизонтальна орієнтація, на зображенні має бути добре видно кожну з секцій.",
  "svg.upload.source_image_label": "Вихідне зображення",
  "svg.upload.success": "SVG-файл успішно завантажено",
  "svg.upload.svg_file_label": "Розмічений SVG-файл",
  "svg.upload.title": "Публічне відображення",
  "toast.lead.was.added": "Лід доданий в роботу!",
  "unit.info.room": "кімн.",
  "unit.popup.add": "+ Додати",
  "unit.popup.add.url": " +Телефон, email або лінк",
  "unit.popup.apartment": "квартира",
  "unit.popup.attic": "мансарда",
  "unit.popup.cancel": "Скасувати",
  "unit.popup.change.params.edit.area": "Змінити площу",
  "unit.popup.change.params.edit.auto.exchange.rate": "Автоматичний курс",
  "unit.popup.change.params.edit.cost": "Вартість юніту",
  "unit.popup.change.params.edit.exchange.rate": "Курс валюти",
  "unit.popup.change.params.edit.for.1usd": "за 1 USD",
  "unit.popup.change.params.edit.per.sqm": "Ціна за кв.м.",
  "unit.popup.change.params.edit.price": "Змінити ціну",
  "unit.popup.change.params.edit.price.per.meter": "встановити ціну за кв.м.",
  "unit.popup.change.params.edit.price.per.unit": "встановити вартість юніту",
  "unit.popup.change.params.title": "Змінити площу і ціну",
  "unit.popup.comment": "Коментар",
  "unit.popup.comment.placeholder": "коментар про ліда",
  "unit.popup.commercial.unit": "комерційне",
  "unit.popup.contact": "Контакт",
  "unit.popup.cottage": "котедж",
  "unit.popup.custom.fields": "Додаткові поля",
  "unit.popup.duplex": "дуплекс",
  "unit.popup.email": "Email",
  "unit.popup.hotel.type": "апартаменти",
  "unit.popup.land.plot": "земельна ділянка",
  "unit.popup.meter": "м",
  "unit.popup.name": "Ім'я",
  "unit.popup.name.placeholder": "Ім'я Прізвище",
  "unit.popup.noname": "Без імені",
  "unit.popup.none": "ні",
  "unit.popup.note.long": "Нотатка в Історію",
  "unit.popup.parking.lot": "паркомісце",
  "unit.popup.pavement.parking": "місце для стоянки",
  "unit.popup.payment.type.deposit": "Депозит",
  "unit.popup.payment.type.fine": "Платіж по штрафу",
  "unit.popup.payment.type.first": "Перший платіж",
  "unit.popup.payment.type.other": "Інший платіж",
  "unit.popup.payment.type.periodical": "Періодичний платіж",
  "unit.popup.payment.type.refund": "Повернення грошей",
  "unit.popup.phone": "Телефон",
  "unit.popup.save": "OK",
  "unit.popup.store.room": "комора",
  "unit.popup.townhouse": "таунхаус",
  "unit.popup.unitdeallead.integration.contact": "контакт",
  "unit.popup.unitdeallead.integration.deal": "угода",
  "unit.popup.unitdeallead.integration.units": "юніти",
  "unit.popup.unitdeallead.payment.select.no": "Ні",
  "unit.popup.unitdeallead.payment.select.one": "Кожен місяць",
  "unit.popup.unitdeallead.payment.select.three": "Раз на квартал",
  "unit.popup.unitdeallead.payment.select.two": "Раз в два місяці",
  "unit.popup.unitdeallead.payment.select.yes": "Так",
  "unit.popup.url": "телефон, email або лінк",
  "unit.popup.villa": "вілла",
  "unit.popup.work_with_lead.in_proposal": "У пропозиції",
  "unit.search.found.total.in.project": "Знайдено <b>{{ total }}</b> квартир в <b>{{ name }}</b>",
  "unit.search.open.filters": "Відкрити фільтри",
  "unit.search.show.other.project.results": "Дивитись в інших ЖК ({{ total }})",
  "unit.search.show.results": "Показати результати",
  "units.page.add.lead.mobile": "Додати ліда з мобільного",
  "units.page.filters": "Фільтри",
  "units.page.filters.show": "показати фільтри",
  "units.page.noresults.neighbours.close": "близький збіг",
  "units.page.noresults.neighbours.exact": "точний збіг",
  "units.page.noresults.reset": "Скинути фільтр",
  "units.page.nounits": "Шахматка ще не створена",
  "units.page.parking": "Паркінг",
  "units.page.print.booked.reserved": "бронь, резерв",
  "units.page.print.stacking.plan.by": "Шахматка EstOffice від",
  "units.page.results.in.section": "Знайдено у секції",
  "units.page.search.panel.close.settings": "Повернутися до фільтрів",
  "units.page.search.panel.display": "Відображення",
  "units.page.search.panel.display.house": "по будинках/пускових комплексах",
  "units.page.search.panel.display.section": "по секціях",
  "units.page.search.panel.from": "від",
  "units.page.search.panel.price": "Вартість",
  "units.page.search.panel.price1sqm": "Ціна 1 кв.м.",
  "units.page.search.panel.prices": "Ціни",
  "units.page.search.panel.reset": "Скинути",
  "units.page.search.panel.rooms": "Кімнати",
  "units.page.search.panel.status": "Статуси",
  "units.page.search.panel.to": "до",
  "units.page.search.panel.view": "Вид",
  "units.page.search.panel.view.fullsize": "повний вигляд",
  "units.page.search.panel.view.hide.sold": "ховати продані",
  "units.page.search.panel.view.minimize": "компактний вигляд",
  "units.page.search.panel.view.show.sold": "показувати продані",
  "units.page.search.panel.view.standard": "стандартний вигляд",
  "units.page.section": "Секція",
  "units.page.sidebar.all.photos": "всі фото",
  "units.page.sidebar.object": "Будівля в обраному проекті",
  "units.page.sidebar.open": "перейти",
  "units.page.sidebar.project": "Проект",
  "units.page.sidebar.public.link": "Публічне посилання",
  "units.page.sidebar.quarter": "кв",
  "units.page.sidebar.sections": "Секції / блоки / групи",
  "units.page.storey": "поверх",
  "working.with.filters.modal.title": "Зберегти фільтри",
  "working.with.filters.save.error": "Не вдалося зберегти фільтри",
  "working.with.filters.saved": "Фільтри збережено",
  "working.with.link.copied": "Посилання скопійовано",
  "working.with.link.copy.error": "Не вдалося скопіювати посилання"
});

$translateProvider.translations("vi", {
  "button.choose_file": "Choose file",
  "button.close": "Close",
  "button.preview": "Preview",
  "button.publish": "Publish",
  "general.add": "Thêm",
  "general.button.export": "Tải thông tin",
  "general.button.next": "Tiếp theo",
  "general.copied": "Đã sao chép!",
  "general.copy": "sao chép",
  "general.current.lang": "vi",
  "general.edit.title": "Chỉnh sửa",
  "general.filters.add": "Chọn ...",
  "general.filters.between": "Giữa ...",
  "general.filters.date.after": "Sau khi ...",
  "general.filters.date.before": "Trước khi ...",
  "general.filters.date.before.30": "Hơn một tháng trước đây",
  "general.filters.date.before.7": "Hơn một tuần trước đây",
  "general.filters.date.month": "Vào tháng...",
  "general.filters.date.on": "Chính xác ngày, tháng ...",
  "general.filters.date.on.short": "ngày",
  "general.filters.date.today": "Hôm nay",
  "general.filters.date.within.30": "Trong 30 ngày qua",
  "general.filters.date.within.7": "Trong 7 ngày qua",
  "general.filters.date.yesterday": "Hôm qua",
  "general.filters.exactly": "Bằng ...",
  "general.filters.has.no": "không",
  "general.filters.has.yes": "có",
  "general.filters.hit.enter": "nhấn Enter để áp dụng",
  "general.filters.less": "Ít hơn ...",
  "general.filters.more": "Nhiều hơn ...",
  "general.gallery.upload": "Tải lên",
  "general.link": "Liên kết",
  "general.modal.are.you.sure": "Bạn có chắc không?",
  "general.modal.doesnt.work.message": "Nếu bạn muốn chức năng này, vui lòng liên hệ với chúng tôi tại support@estoffice.com",
  "general.modal.doesnt.work.title": "Chưa khả dụng",
  "general.modal.got.it": "OK",
  "general.month.april": "Tháng Tư",
  "general.month.august": "Tháng Tám",
  "general.month.december": "Tháng Mười Hai",
  "general.month.february": "Tháng Hai",
  "general.month.january": "Tháng Một",
  "general.month.july": "Tháng Bảy",
  "general.month.june": "Tháng Sáu",
  "general.month.march": "Tháng Ba",
  "general.month.may": "Tháng Năm",
  "general.month.november": "Tháng Mười Một",
  "general.month.october": "Tháng Mười",
  "general.month.september": "Tháng Chín",
  "general.months": "months",
  "general.saving": "Đang lưu...",
  "general.search.not.found": "Không tìm được",
  "general.search.placeholder": "Tìm kiếm ...",
  "general.update": "Cập nhật",
  "general.working.with": "Làm việc với",
  "lead.popup.area": "Khu vực",
  "lead.popup.expires.days": "ngày",
  "lead.popup.expires.days.full": "ngày",
  "lead.popup.expires.leads.full": "leads",
  "lead.popup.links.room": "-phòng",
  "lead.popup.links.sqm": "m2",
  "lead.popup.num": "Số chung cư",
  "leads.buttons.add.note": "Thêm ghi chú",
  "leads.buttons.bulk.edit": "Chỉnh sửa hàng loạt",
  "leads.buttons.bulk.note.adding": "Thêm ghi chú hàng loạt",
  "leads.buttons.bulk.note.update": "Cập nhật",
  "leads.buttons.bulk.note.with.note": "Khách hàng có ghi chú",
  "leads.buttons.bulk.status.change": "Thay đổi trạng thái hàng loạt",
  "leads.buttons.bulk.status.change.status.of": "Thay đổi trạng thái của",
  "leads.buttons.bulk.status.leads.to": "Khách hàng",
  "leads.buttons.change.status": "Thay đổi trạng thái",
  "leads.buttons.sort": "Sắp xếp",
  "leads.buttons.sort.date.updated": "Ngày cập nhật",
  "leads.buttons.sort.lead.status": "Trạng thái khách hàng",
  "leads.mobile.add.from.clipboard": "Dán số điện thoại từ bộ nhớ đệm",
  "leads.mobile.add.long.tap": "Nhấn và giữ",
  "leads.mobile.add.toast.msg": "Một khách hàng mới đã được tạo!",
  "leads.search.create.new": "Khách hàng mới",
  "leads.search.create.new.appeal.source": "Appeal source",
  "leads.search.create.new.disabled.tooltip": "Bạn chưa điền tất cả các trường bắt buộc",
  "leads.search.create.new.items": "Loại căn hộ quan tâm",
  "leads.search.create.new.newlead": "Khách hàng mới",
  "leads.search.create.new.projects": "Dự án",
  "leads.search.create.new.save.and.add.to.clipboard": "Lưu và thêm vào bộ nhớ đệm",
  "leads.search.create.new.save.lead": "Lưu khách hàng",
  "leads.search.create.new.segmentation": "Phân khúc",
  "leads.search.create.new.status.tooltip": "Chọn trạng thái khách hàng...",
  "leads.search.records": "Khách hàng",
  "leads.search.tab.tooltip": "Nhấn tab để bắt đầu nhập",
  "leads.sidebar.filter.and.work": "Lọc và làm việc",
  "leads.sidebar.lead.action": "Hoạt động với khách hàng",
  "leads.sidebar.lead.has.email": "Có email",
  "leads.sidebar.lead.has.note": "Có ghi chú khách hàng",
  "leads.sidebar.lead.has.phone": "Có điện thoại",
  "leads.sidebar.lead.has.task": "Has lead task(s)",
  "leads.sidebar.lead.items.interest": "Hạng mục quan tâm",
  "leads.sidebar.lead.items.interest.1r": "1p",
  "leads.sidebar.lead.items.interest.2r": "2p",
  "leads.sidebar.lead.items.interest.3r": "3p",
  "leads.sidebar.lead.items.interest.ground": "trệt",
  "leads.sidebar.lead.items.interest.ready": "Có sẵn",
  "leads.sidebar.lead.items.interest.studio": "Căn studio",
  "leads.sidebar.lead.project": "Dự án",
  "leads.sidebar.lead.record": "Hồ sơ khách hàng",
  "leads.sidebar.lead.status": "Trạng thái khách hàng",
  "leads.sidebar.main.what": "Hoạt động gì",
  "leads.sidebar.main.what.reservation.options": "Lựa chọn đặt trước",
  "leads.sidebar.main.what.reservation.options.duration": "Thời hạn",
  "leads.sidebar.main.what.reservation.options.expiration": "Hết hạn",
  "leads.sidebar.main.what.reservation.options.status": "Tình trạng",
  "leads.sidebar.main.when": "Khi nào",
  "leads.sidebar.main.where": "Ở đâu",
  "leads.sidebar.main.where.floor.area": "Diện tích sàn",
  "leads.sidebar.main.where.rooms": "Phòng",
  "leads.sidebar.main.where.sections": "Tháp",
  "leads.sidebar.main.where.storey": "Tầng",
  "leads.sidebar.main.where.type": "Loại",
  "leads.sidebar.main.where.type.group.individual": "Individual housing",
  "leads.sidebar.main.where.type.group.main": "Group housing and commerce",
  "leads.sidebar.main.where.type.group.other": "Other",
  "leads.sidebar.main.where.unique.id": "Số duy nhất",
  "leads.sidebar.main.who": "Ai",
  "leads.sidebar.notes": "Ghi chú",
  "leads.sidebar.notes.content": "Nội dung",
  "leads.sidebar.notes.date": "Ngày cập nhật",
  "leads.sidebar.notes.has.notes": "Có ghi chú",
  "leads.sidebar.notes.quantity": "Số lượng",
  "leads.sidebar.only.leads": "Only leads",
  "leads.sidebar.only.my.leads": "Chỉ khách hàng của tôi",
  "leads.sidebar.select.created": "Đã tạo",
  "leads.sidebar.select.note.user": "Đã tạo ghi chú",
  "leads.sidebar.select.price.1sqm": "Giá 1 mét vuông",
  "leads.sidebar.select.price.total": "Tổng giá",
  "leads.sidebar.select.reservation.status.active": "Đang hoạt động",
  "leads.sidebar.select.reservation.status.inactive": "Không hoạt động",
  "leads.sidebar.select.total.area": "Tổng diện tích",
  "leads.sidebar.select.updated": "Cập nhật lần cuối",
  "leads.sidebar.select.what.booked": "Đã đặt chỗ",
  "leads.sidebar.select.what.canceled.deal": "Giao dịch đã hủy",
  "leads.sidebar.select.what.extended.reservation": "Gia hạn đặt trước",
  "leads.sidebar.select.what.interested": "Quan tâm",
  "leads.sidebar.select.what.purchased": "Đã mua",
  "leads.sidebar.select.what.updated.deal": "Giao dịch đã cập nhật",
  "leads.sidebar.smart.tasks": "Nhiệm vụ thông minh",
  "leads.sidebar.smart.tasks.everyday": "Mỗi ngày",
  "leads.sidebar.smart.tasks.once": "Mỗi thứ tư",
  "leads.sidebar.smart.tasks.twice": "Mỗi thứ Ba và thứ Sáu",
  "leads.sidebar.unit.status": "Trạng thái căn hộ",
  "leads.sidebar.user.created": "Người đã tạo",
  "leads.sidebar.user.updated": "Người cập nhật",
  "leads.table.created.at": "Ngày tạo",
  "leads.table.created.by": "Tạo bởi",
  "leads.table.ibp": "Quan tâm / Đã đặt chỗ / Đã mua",
  "leads.table.last.action": "Hoạt động cuối",
  "leads.table.updated.by": "Cập nhật bởi",
  "navi.all_sold": "All sold",
  "navi.area": "Toàn bộ khu vực",
  "navi.button": "navi",
  "navi.in_stock": "In stock",
  "navi.incoming": "Sắp có hàng",
  "navi.modal.back": "Quay lại",
  "navi.modal.title": "Interactive navigation",
  "navi.not_in_stock": "Not in stock",
  "navi.num.of.storeys": "Số tầng",
  "navi.price.from": "Giá từ",
  "navi.price.per.m": "/m",
  "navi.publish.error": "Error publishing navi",
  "navi.publish.preview": "Preview",
  "navi.publish.success": "Interactive navigation was successfully published",
  "navi.return.to.navi": "Quay lại trang hoạch tổng thể",
  "navi.scroll.horizontally": "cuộn theo chiều ngang",
  "navi.section.class": "Cấp",
  "navi.sold.out": "Bán hết",
  "objects.navi.panel.group.see_also": "Xem thêm",
  "objects.navi.panel.group.selected": "Đã chọn",
  "projects.area.fill": "Cài đặt",
  "projects.area.kitchen": "Bếp",
  "projects.area.living": "Phòng khách",
  "projects.area.plot.size": "Kích thước lô đắt",
  "projects.area.set.commercial": "Đặt tổng khu vực thương mại",
  "projects.area.set.plot": "Đặt kích thước lô đất",
  "projects.area.set.text": "Tổng diện tích là thông tin cần thiết. Diện tích nhà bếp và khu vực sinh sống là không bắt buộc.",
  "projects.area.set.title": "Đặt tổng diện tích, khu vực phòng khách và bếp",
  "projects.area.show.all": "Hiện cả ba",
  "projects.area.total": "Tổng số",
  "projects.basic.basement": "Hầm",
  "projects.basic.bind_to_single_floor": "Liên kết với một tầng",
  "projects.basic.commercial": "Căn hộ thương mại",
  "projects.basic.completed": "Đã hoàn thành",
  "projects.basic.completion.date": "Ngày hoàn thành",
  "projects.basic.completion.date.unset": "not set",
  "projects.basic.construction": "Xây dựng",
  "projects.basic.construction.stage": "Giai đoạn xây dựng",
  "projects.basic.create": "Tạo bản đồ hai chiều",
  "projects.basic.create.check": "Hãy kiểm tra lại! Sau này bạn không thể thay đổi được.",
  "projects.basic.create.cta": "Create units",
  "projects.basic.floor_override": "Số tầng",
  "projects.basic.grid.edit": "Chỉnh sửa lưới",
  "projects.basic.grid.params": "Tùy chọn lưới",
  "projects.basic.mark": "Đánh dấu",
  "projects.basic.merge": "Merge / Undo",
  "projects.basic.nounit": "Không có căn hộ nào",
  "projects.basic.parking": "Hầm đỗ xe",
  "projects.basic.per.storey": "Số căn hộ mỗi tầng",
  "projects.basic.split": "Split / Undo",
  "projects.basic.stage.completion": "Giai đoạn và ngày hoàn thành",
  "projects.basic.storeys": "Tầng",
  "projects.basic.units.horizontally": "Các căn hộ theo chiều ngang",
  "projects.basic.units.vertically": "Các căn hộ theo chiều dọc",
  "projects.features.custom.fields": "Trường tùy chỉnh",
  "projects.features.custom.fields.no": "Bạn chưa thêm trường tùy chỉnh đơn nào. Đi đến mục Tùy chỉnh để thêm",
  "projects.features.features": "Đặc điểm",
  "projects.features.helptext.1part": "Để áp dụng trường tùy chỉnh cho tất cả căn hộ nhấn",
  "projects.features.helptext.2part": "sẽ áp dụng đặc điểm hoặc thông tin tùy chỉnh lần lượt cho cột thứ nhất, thứ hai, và thứ n.",
  "projects.images.all.units": "Tất cả căn hộ",
  "projects.images.floor.plans": "Kế hoạch theo tầng",
  "projects.images.floor.plans.units": "Kế hoạch theo tầng của căn hộ",
  "projects.images.linked.to": "Được liên kết với",
  "projects.images.linked.to.units": "Căn hộ",
  "projects.images.master.plans": "Kế hoạch tổng thể",
  "projects.images.visual.units": "Mô phỏng căn hộ",
  "projects.numbering.button.autoset": "Thiết lập tự động",
  "projects.numbering.button.startover": "Đặt lại",
  "projects.numbering.id": "Số bên trong tháp",
  "projects.numbering.id.block.block": "Dãy nhà",
  "projects.numbering.id.block.corresponds": "Tương ứng với Khu K1, căn số #12",
  "projects.numbering.id.block.example": "VÍ DỤ: K1-12",
  "projects.numbering.id.block.first": "Định dạng số bên trong khu biệt thự",
  "projects.numbering.id.block.first.text": "Thêm dấu phân cách và tùy chỉnh câu chữ nếu cần. Sau đó nhấp vào \"Thiết lập tự động\". Nếu làm sai, nhấp vào \"Bắt đầu lại\".",
  "projects.numbering.id.block.second": "Sửa căn hộ # trong mỗi ô",
  "projects.numbering.id.block.second.text": "Trường đầu vào thứ hai có thể sửa được. Hãy chắc chắn mỗi căn hộ có một số duy nhất.",
  "projects.numbering.id.floor": "Tầng",
  "projects.numbering.id.tower.corresponds": "Tương ứng với tháp B1, tầng # 2, căn hộ # 3",
  "projects.numbering.id.tower.example": "VÍ DỤ: B1-02-3",
  "projects.numbering.id.tower.first": "Cài số căn hộ",
  "projects.numbering.id.tower.first.text": "Dùng trường đầu vào dưới các cột. Sau đó thông tin đầu vào sẽ được dùng để tại số bên trong tháp",
  "projects.numbering.id.tower.second": "Định dạng số bên trong tháp",
  "projects.numbering.id.tower.second.text": "Sửa số đã tạo nếu cần. Trường đầu vào thứ hai có thể chỉnh được.",
  "projects.numbering.id.tower.tower": "Tháp",
  "projects.numbering.id.unit": "Căn hộ",
  "projects.numbering.number.first": "Căn hộ đầu tiên #",
  "projects.numbering.number.last": "Căn hộ cuối cùng #",
  "projects.numbering.number.split": "Chỉ đánh số căn hộ tách ra đầu tiên",
  "projects.numbering.pass": "Đi qua",
  "projects.numbering.skip.commercial": "Bỏ qua căn thương mại",
  "projects.numbering.title": "Đánh số",
  "projects.page.add.new.building": "Thêm một tòa nhà cao tầng",
  "projects.page.add.new.project": "+ Thêm dự án mới",
  "projects.page.add.new.project.popup.title": "Dự án mới",
  "projects.page.add.new.villas": "Add parking / storage / private housing",
  "projects.page.edit.prices": "Chỉnh sửa giá",
  "projects.page.edit.units": "Chỉnh sửa đơn vị",
  "projects.page.no.projects": "No projects yet",
  "projects.page.popup.add.block": "Thêm một khu",
  "projects.page.popup.add.section": "Thêm một tháp",
  "projects.page.popup.blocks": "Khu biệt thự",
  "projects.page.popup.completion": "Hoàn thành",
  "projects.page.popup.edit.title": "chỉnh sửa",
  "projects.page.popup.sections": "Tháp",
  "projects.page.popup.start.of.sales": "Start of sales",
  "projects.page.popup.status": "Trạng thái",
  "projects.page.popup.successfully.created": "Tạo thành công!",
  "projects.page.popups.add.block": "Thêm",
  "projects.page.popups.add.building": "Thêm toà nhà",
  "projects.page.popups.add.section": "Thêm",
  "projects.page.popups.block.index": "Mục lục",
  "projects.page.popups.block.index.placeholder": "Số, chữ cái, v.v...",
  "projects.page.popups.building.name": "Tên tòa nhà",
  "projects.page.popups.building.name.placeholder": "House #1",
  "projects.page.popups.contact.page": "Liên kết với trang liên hệ",
  "projects.page.popups.description.page": "Liên kết đến mô tả",
  "projects.page.popups.if.diff": "nếu khác với dự án ...",
  "projects.page.popups.project.city": "thành phố",
  "projects.page.popups.project.city.placeholder": "Tokyo",
  "projects.page.popups.project.country": "Nước",
  "projects.page.popups.project.create": "Dự án mới",
  "projects.page.popups.project.location": "Địa điểm",
  "projects.page.popups.project.location.placeholder": "Đường",
  "projects.page.popups.project.name": "Tên dự án",
  "projects.page.popups.project.name.placeholder": "Crystal City...",
  "projects.page.popups.section.index": "Mục lục",
  "projects.page.popups.villas.blocks": "Khu",
  "projects.page.popups.villas.create.holder": "Tạo căn biệt thự",
  "projects.page.popups.villas.holder.name": "Tên căn biệt thự",
  "projects.page.popups.villas.holder.name.placeholder": "Villas và nhà phố...",
  "projects.page.sheets.step1.create.btn": "Create table",
  "projects.page.sheets.step1.create.text": "Or create table-template for a new date.",
  "projects.page.sheets.step1.drafts": "Drafts",
  "projects.page.sheets.step1.hint": "Please specify a target start date for prices you want to add. This will allow us to create all the right columns.",
  "projects.page.sheets.step1.li1": "change prices of all or some of the units",
  "projects.page.sheets.step1.li2": "increase/decrease price by a percentage or amount",
  "projects.page.sheets.step1.li3": "round the calculated price",
  "projects.page.sheets.step1.subtitle": "Using this table you will be capable to:",
  "projects.page.sheets.step1.title": "Step 1. Create table-template",
  "projects.page.sheets.step1.unitsData.li1": "set the areas (total, living, kitchen)",
  "projects.page.sheets.step1.unitsData.li2": "set the number of rooms",
  "projects.page.sheets.step1.unitsData.li3": "set numbering",
  "projects.page.sheets.step1.unitsData.li4": "change unit type",
  "projects.page.sheets.step1.unitsData.li5": "set the type of layout",
  "projects.page.sheets.step1.unitsData.li6": "set government id",
  "projects.page.sheets.step2.cancel.btn": "Cancel and delete table",
  "projects.page.sheets.step2.cancel.btn.toast": "Table-draft was deleted!",
  "projects.page.sheets.step2.import.btn": "Import table to EstOffice",
  "projects.page.sheets.step2.import.btn.toast": "Successfully imported!",
  "projects.page.sheets.step2.import.error": "Error during import. Please correct mistakes in your spreadsheet and try importing again.",
  "projects.page.sheets.step2.title": "Step 2. Editing the table",
  "projects.page.sheets.step2.when.finished": "When finished with editing – import your table.",
  "projects.page.sheets.step2.you.can.edit": "You may edit values in the columns marked with active orange color.",
  "projects.page.units.noprice": "Unit(s) without price:",
  "projects.price.prices": "Giá",
  "projects.price.unique.1part": "Nếu mỗi căn hộ có giá khác nhau - dùng phương pháp khác. Mở",
  "projects.price.unique.2part": "Dán giá căn hộ ở tầng đầu tiên vào cột đầu tiên. Công thức sẽ tự tạo chuỗi giá, được cách nhau bằng dấu cách. Bây giờ dán nó vào căn hộ đầu tiên ở tầng đầu tiên. Lặp lại bước này cho các tầng còn lại của tháp.",
  "projects.price.unique.link": "Google Spreadsheets",
  "projects.progress.area": "Khu vực",
  "projects.progress.basic": "Cơ bản",
  "projects.progress.features": "Đặc điểm",
  "projects.progress.images": "Hình ảnh",
  "projects.progress.num": "Đánh số",
  "projects.progress.price": "Giá",
  "projects.progress.published": "Đăng lên",
  "projects.progress.review": "Xem lại",
  "projects.progress.rooms": "Phòng",
  "projects.review.public.view.tip": "Manage access to sections using «Public view & navigation» on screen",
  "projects.review.public.view.tip.projects": "Projects",
  "projects.review.publishing.status": "Trạng thái đăng",
  "projects.review.publishing.status.draft": "Nháp",
  "projects.review.publishing.status.published": "Đã đăng",
  "projects.review.publishing.status.unknown": "Không có dữ liệu",
  "projects.review.quick.status": "Thay đổi nhanh trạng thái",
  "projects.review.quick.status.booked": "Đã đặt chỗ",
  "projects.review.quick.status.free": "Có sẵn",
  "projects.review.quick.status.notinstock": "Không bán",
  "projects.review.quick.status.sold": "Đã bán",
  "projects.review.save": "Lưu",
  "projects.review.save.modal.draft.content": "Bộ phận kinh doanh sẽ không nhìn thấy phần này.",
  "projects.review.save.modal.draft.title": "Lưu dưới bản nháp",
  "projects.review.save.modal.published.content": "Phần có trạng thái tiến độ. Bộ phận kinh doanh sẽ có thể đặt chỗ và bán.",
  "projects.review.save.modal.published.title": "Đã đăng",
  "projects.review.text": "Kiểm tra tất cả thông tin. Bạn có thể quay trở lại bất kỳ bước nào nếu cần thay đổi.",
  "projects.review.title": "Xem lại và đăng lên",
  "projects.rooms.commercial": "Thương mại",
  "projects.rooms.set.text": "Đặt số 1, 2, 3 cho mỗi căn hộ. Để đặt một giá trị chung, dùng trường đầu vào trên mỗi cột.",
  "projects.rooms.set.title": "Đặt số phòng khách",
  "projects.rooms.statistics": "Thống kê",
  "projects.rooms.total": "Tổng số",
  "projects.set.all.unit.type": "Set type of all units",
  "projects.unit.type.apt": "Căn hộ",
  "projects.unit.type.commercial": "Căn thương mại",
  "projects.unit.type.plot": "Lô",
  "projects.unit.type.villa": "Biệt thự",
  "reports.page.byprojects.all.time": "Toàn bộ thời gian",
  "reports.page.byprojects.annual": "Báo cáo năm",
  "reports.page.byprojects.deals.full": "Giao dịch thanh toán 100%",
  "reports.page.byprojects.deals.value.total": "Tổng giá trị giao dịch",
  "reports.page.byprojects.deals.value.total.mln": "thu nhập, mln",
  "reports.page.byprojects.monthly": "Báo cáo tháng",
  "reports.page.byprojects.nodata": "Không có dữ liệu",
  "reports.page.byprojects.weekly": "Báo cáo tuần",
  "reports.page.dashboard.active.leads": "leads with target action",
  "reports.page.dashboard.created": "created new",
  "reports.page.dashboard.data.updated": "Data updated:",
  "reports.page.dashboard.day": "Ngày",
  "reports.page.dashboard.deals": "Giao dịch",
  "reports.page.dashboard.deals.value": "giá trị giao dịch",
  "reports.page.dashboard.interacted": "interacted",
  "reports.page.dashboard.interests": "quan tâm",
  "reports.page.dashboard.last": "Last",
  "reports.page.dashboard.month": "Tháng",
  "reports.page.dashboard.new.leads": "new leads",
  "reports.page.dashboard.percentage.tooltip": "so với kỳ trước",
  "reports.page.dashboard.q1": "Who is the leader in lead nurturing?",
  "reports.page.dashboard.q1.tip": "Sum of daily counts per employee. Bigger number indicates that an employee contacted more leads during last 30/90 days. Following interaction types are included: notes, tasks, calls, custom fields updates.",
  "reports.page.dashboard.q2": "What are the most active days for lead nurturing?",
  "reports.page.dashboard.q2.tip": "Shows the number of created and updated leads per day. If values of updated and created are equal, only new leads were touched on that day.",
  "reports.page.dashboard.reservations": "Đặt trước",
  "reports.page.dashboard.updated.leads": "leads with interaction",
  "reports.page.dashboard.week": "Tuần",
  "reports.page.dashboard.year": "Năm",
  "reports.page.filter.all.projects": "Tất cả các dự án",
  "reports.page.lead.working.q1": "Avg amount of days in the current status",
  "reports.page.lead.working.q1.tip": "The statuses in the chart belong to the sales funnel. So the leads are supposed to be moving along the sales funnel, not be stuck for many days.",
  "reports.page.menu.employee.all": "All employees",
  "reports.page.menu.employee.sales": "Sales by employee",
  "reports.page.menu.stock.analysis": "Hàng tồn kho",
  "reports.page.sales.by.time.count": "định lượng",
  "reports.page.sales.by.time.income": "thu nhập",
  "reports.page.sales.by.time.months": "theo tháng",
  "reports.page.sales.by.time.sqm": "trong mét vuông",
  "reports.page.sales.by.time.value": "doanh thu",
  "reports.page.sales.by.time.weeks": "theo tuần",
  "reports.page.sidebar.byprojects": "Tổng quan dự án",
  "reports.page.sidebar.dashboard": "Bảng điều khiển",
  "reports.page.sidebar.export.data": "Xuất dữ liệu",
  "reports.page.sidebar.intervals": "Day, month, year",
  "reports.page.sidebar.lead.working": "Lead nurturing",
  "reports.page.sidebar.leads.by.status": "Employee leads by status",
  "reports.page.sidebar.projects.alltime": "Bán hàng theo thời gian",
  "reports.page.stock.analysis.q1": "Do we have enough stock to sell?",
  "reports.page.stock.analysis.q1.tip": "report includes units that have defined total area",
  "reports.page.stock.analysis.q2": "Is what we have in stock in demand? Maybe we have some stale goods?",
  "reports.page.stock.analysis.q2.tip": "only free and booked units are taken into account",
  "reports.page.stock.analysis.q3": "Apartments of which type a present in the stock?",
  "settings.document.templates.title": "Document templates",
  "settings.opportunity.labels.title": "Các giai đoạn và trạng thái",
  "settings.page.customizations.custom.table.name": "Tên",
  "settings.page.customizations.custom.type.choice": "Lựa chọn",
  "settings.page.customizations.custom.type.date": "Ngày",
  "settings.page.customizations.custom.type.number": "Số",
  "settings.page.customizations.custom.type.text": "Chữ",
  "settings.page.customizations.customizations": "Tùy chỉnh",
  "settings.page.customizations.default.currency": "Loại tiền mặc định",
  "settings.page.customizations.land.measure": "Kích thước căn hộ lô đất",
  "settings.page.customizations.lead.statuses": "Trạng thái khách hàng",
  "settings.page.customizations.lead.statuses.placeholder": "Tên trạng thái ...",
  "settings.page.customizations.lead.statuses.separator": "+ Thêm dấu ngăn cách",
  "settings.page.customizations.menu.appeal.sources": "Appeal sources",
  "settings.page.customizations.menu.custom.fields": "Custom fields",
  "settings.page.customizations.menu.customizations": "Tùy chỉnh",
  "settings.page.customizations.menu.embed": "Embed on a website",
  "settings.page.customizations.menu.integrations": "Integrations",
  "settings.page.customizations.menu.loans": "Loans",
  "settings.page.customizations.menu.requests": "Appeals",
  "settings.page.customizations.menu.stacking.plan": "Stacking plan",
  "settings.page.customizations.menu.users": "Người dùng",
  "settings.page.customizations.price.lists": "Giá",
  "settings.page.customizations.price.lists.begin": "Bắt đầu",
  "settings.page.customizations.price.lists.end": "Kết thúc",
  "settings.page.customizations.price.lists.name": "Tên",
  "settings.page.customizations.price.lists.parent": "Trên cơ sở",
  "settings.page.customizations.time.zone": "Múi giờ",
  "settings.page.customizations.unit.features": "Đặc điểm của căn hộ",
  "settings.page.customizations.unit.features.abbr.placeholder": "Viết tắt ...",
  "settings.page.customizations.unit.features.name.placeholder": "Tên tính năng ...",
  "settings.page.customizations.unit.features.table.abbr": "Viết tắt.",
  "settings.page.customizations.unit.features.table.name": "Tên",
  "settings.page.customizations.unit.status.cant.delete_1": "Total units with this status:",
  "settings.page.customizations.unit.status.cant.delete_2": "Set a new status to replaced removed one.",
  "settings.page.customizations.unit.status.confirm.delete": "Please confirm status removal",
  "settings.page.customizations.unit.statuses": "Trạng thái căn hộ",
  "settings.page.customizations.unit.statuses.placeholder": "Tên trạng thái...",
  "settings.page.customizations.unit.statuses.remove": "Unit status removal",
  "settings.page.customizations.unit.statuses.type.booked": "Đã đặt căn hộ",
  "settings.page.customizations.unit.statuses.type.free": "Có sẵn",
  "settings.page.customizations.unit.statuses.type.notinstock": "Không bán",
  "settings.page.customizations.unit.statuses.type.sold": "Đã bán",
  "settings.page.users.deactivated.at": "Deactivated at",
  "settings.page.users.modal.name": "Họ và tên",
  "settings.page.users.modal.name.caution": "Vui lòng không dùng dấu chấm, viết đầy đủ họ tên",
  "settings.page.users.modal.name.placeholder": "Nguyen Van An",
  "settings.page.users.modal.note": "Lưu ý",
  "settings.page.users.modal.password": "Mật khẩu",
  "settings.page.users.modal.role": "Vai trò",
  "settings.page.users.modal.title.newuser": "Người dùng mới",
  "settings.page.users.modal.title.update": "Cập nhật người dùng",
  "settings.page.users.title.active": "Active",
  "settings.page.users.title.deactivated": "Deactivated",
  "svg.upload.draft_plan_image_hint": "Upload an image that shows the section boundaries and their names. Create all sections in EstOffice.",
  "svg.upload.draft_plan_image_label": "Navigation markup example",
  "svg.upload.format.error": "You have uploaded improperly formatted svg file. Please contact technical support to get additional help.",
  "svg.upload.house.public.view.and.plan": "Public view & navigation",
  "svg.upload.navi_link_label": "Interactive navigation link:",
  "svg.upload.preview_image_label": "Final image",
  "svg.upload.published_navi": "Published navigation",
  "svg.upload.section_published_flag": "published",
  "svg.upload.sections.status.tip": "If nothing is selected, all published sections will appear in public view.",
  "svg.upload.sections.status.title": "Public status of sections",
  "svg.upload.source_image_hint": "High resolution, horizontal orientation, each section should be clearly visible on the image.",
  "svg.upload.source_image_label": "Source image",
  "svg.upload.success": "SVG-file was successfully uploaded",
  "svg.upload.svg_file_label": "Prepared markup SVG-file",
  "svg.upload.title": "Public view",
  "toast.lead.was.added": "Khách hàng đã được thêm!",
  "unit.info.room": "Phòng",
  "unit.popup.add": "+ Thêm",
  "unit.popup.add.url": "+ Thêm điện thoại, email hoặc liên kết",
  "unit.popup.apartment": "Chung cư",
  "unit.popup.attic": "attic",
  "unit.popup.cancel": "Hủy",
  "unit.popup.change.params.edit.area": "Edit total area",
  "unit.popup.change.params.edit.auto.exchange.rate": "Auto exchange rate",
  "unit.popup.change.params.edit.cost": "Total cost",
  "unit.popup.change.params.edit.exchange.rate": "Exchange rate",
  "unit.popup.change.params.edit.for.1usd": "for 1 USD",
  "unit.popup.change.params.edit.per.sqm": "Price of sqm",
  "unit.popup.change.params.edit.price": "Edit price",
  "unit.popup.change.params.edit.price.per.meter": "set price per sqm",
  "unit.popup.change.params.edit.price.per.unit": "set unit total cost",
  "unit.popup.change.params.title": "Change area and price",
  "unit.popup.comment": "Bình luận",
  "unit.popup.comment.placeholder": "Ghi nhớ về khách hàng",
  "unit.popup.commercial.unit": "Căn thương mại",
  "unit.popup.contact": "Liên hệ",
  "unit.popup.cottage": "cottage",
  "unit.popup.custom.fields": "Trường tùy chỉnh",
  "unit.popup.duplex": "duplex",
  "unit.popup.email": "Email",
  "unit.popup.hotel.type": "hotel type",
  "unit.popup.land.plot": "Lô đất",
  "unit.popup.meter": "m",
  "unit.popup.name": "Tên",
  "unit.popup.name.placeholder": "Họ",
  "unit.popup.noname": "Không tên",
  "unit.popup.none": "Không",
  "unit.popup.note.long": "Lưu ý",
  "unit.popup.parking.lot": "parking lot",
  "unit.popup.pavement.parking": "pavement parking",
  "unit.popup.payment.type.deposit": "Đặt cọc",
  "unit.popup.payment.type.fine": "Tiền phạt",
  "unit.popup.payment.type.first": "Thanh toán lần đầu",
  "unit.popup.payment.type.other": "Khác",
  "unit.popup.payment.type.periodical": "Thanh toán định kỳ",
  "unit.popup.payment.type.refund": "Hoàn trả",
  "unit.popup.phone": "Điện thoại",
  "unit.popup.save": "Lưu",
  "unit.popup.store.room": "store room",
  "unit.popup.townhouse": "Nhà phố",
  "unit.popup.unitdeallead.integration.contact": "contact",
  "unit.popup.unitdeallead.integration.deal": "deal",
  "unit.popup.unitdeallead.integration.units": "units",
  "unit.popup.unitdeallead.payment.select.no": "Không đồng ý",
  "unit.popup.unitdeallead.payment.select.one": "Hàng tháng",
  "unit.popup.unitdeallead.payment.select.three": "Hàng quý",
  "unit.popup.unitdeallead.payment.select.two": "Mỗi hai tháng",
  "unit.popup.unitdeallead.payment.select.yes": "Đồng ý",
  "unit.popup.url": "Điện thoại, email hoặc liên kết",
  "unit.popup.villa": "Biệt thự",
  "unit.popup.work_with_lead.in_proposal": "Proposed",
  "unit.search.found.total.in.project": "Found <b>{{ total }}</b> apartments in <b>{{ name }}</b>",
  "unit.search.open.filters": "Open filters",
  "unit.search.show.other.project.results": "Look in other projects ({{ total }})",
  "unit.search.show.results": "Show results",
  "units.page.add.lead.mobile": "Thêm khách hàng từ di động",
  "units.page.filters": "Filters",
  "units.page.filters.show": "show filters",
  "units.page.noresults.neighbours.close": "Gần phù hợp như đã lọc",
  "units.page.noresults.neighbours.exact": "Phù hợp chính xác như đã lọc",
  "units.page.noresults.reset": "Đặt lại bộ lọc",
  "units.page.nounits": "Chưa có căn hộ nào",
  "units.page.parking": "Đậu xe",
  "units.page.print.booked.reserved": "Đã đặt chỗ",
  "units.page.print.stacking.plan.by": "Bản đồ hai chiều bởi EstOffice ngày",
  "units.page.results.in.section": "Tìm thấy trong Tháp",
  "units.page.search.panel.close.settings": "Quay lại bộ lọc",
  "units.page.search.panel.display": "Display",
  "units.page.search.panel.display.house": "by buildings/phases",
  "units.page.search.panel.display.section": "by sections",
  "units.page.search.panel.from": "từ",
  "units.page.search.panel.price": "Tổng giá",
  "units.page.search.panel.price1sqm": "Giá 1 mét vuông",
  "units.page.search.panel.prices": "Giá",
  "units.page.search.panel.reset": "Đặt lại",
  "units.page.search.panel.rooms": "Phòng",
  "units.page.search.panel.status": "Trạng thái",
  "units.page.search.panel.to": "đến",
  "units.page.search.panel.view": "Xem",
  "units.page.search.panel.view.fullsize": "Xem đủ thông tin",
  "units.page.search.panel.view.hide.sold": "ẩn đã bán",
  "units.page.search.panel.view.minimize": "Xem thu gọn",
  "units.page.search.panel.view.show.sold": "hiển thị đã bán",
  "units.page.search.panel.view.standard": "Xem tiêu chuẩn",
  "units.page.section": "Tháp",
  "units.page.sidebar.all.photos": "Tất cả hình ảnh",
  "units.page.sidebar.object": "Tòa nhà trong dự án đã chọn",
  "units.page.sidebar.open": "mở",
  "units.page.sidebar.project": "Dự án",
  "units.page.sidebar.public.link": "Liên kết công khai",
  "units.page.sidebar.quarter": "Q",
  "units.page.sidebar.sections": "Sections / blocks / groups",
  "units.page.storey": "Tầng",
  "working.with.filters.modal.title": "Lưu bộ lọc",
  "working.with.filters.save.error": "Không thể lưu bộ lọc",
  "working.with.filters.saved": "Bộ lọc đã được lưu",
  "working.with.link.copied": "Đã sao chép liên kết",
  "working.with.link.copy.error": "Không thể sao chép liên kết"
});
}]);
